// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:05:54.384Z
// Property: Parc at West Point (ID: 6767906449166338)
// Collections: 36 amenities, 12 floorplans (live), 28 photos, 80 POIs, 4 reviews, 1 virtual tours, 6 office hours, 2 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166338",
  "property_external_id": "30939",
  "property_zillow_url": "https://www.zillow.com/apartments/north-wales-pa/parc-at-west-point/5XjW9v/",
  "property_apartments_url": "https://www.apartments.com/parc-at-west-point-north-wales-pa/xbbvg8m/",
  "property_google_business_url": "https://www.google.com/maps/place/Parc+at+West+Point+Apartment+Homes/data=!4m2!3m1!1s0x0:0x3478683fce29452e?sa=X&ved=2ahUKEwiw8LyY1riSAxWxRaQEHTB_KjkQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "parc-at-west-point",
  "property_name": "Parc at West Point",
  "property_website_url": "https://www.parcatwestpoint.com/",
  "property_domain": "https://www.parcatwestpoint.com/",
  "property_address": "131 Church Road",
  "property_full_address": "131 Church Rd, North Wales, PA 19454",
  "property_address_1": "131 Church Rd",
  "property_address_2": null,
  "property_address_city": "North Wales",
  "property_address_state": "PA",
  "property_address_zip_full": "19454-4141",
  "property_address_zip": "19454",
  "property_address_country": "US",
  "property_address_county": "Montgomery County",
  "property_neighborhood_address": "Upper Montgomery County",
  "property_address_latitude": "40.2185529",
  "property_address_longitude": "-75.2898305",
  "property_email": "parcwestpoint@aionmanagement.com",
  "property_phone": "(267) 746-3208",
  "property_call_tracking_phone": "844-619-9260",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Parc at West Point in North Wales, PA, our thoughtfully designed one, two, and three-bedroom apartments offer luxurious living with stunning views and modern amenities. Enjoy high-speed internet, a refreshing swimming pool, and a pet-friendly atmosphere, all while maintaining the convenience of flex rent payments and online management.",
  "property_long_description": "**Welcome to Parc at West Point – Your Ideal Apartment Community in North Wales, PA!**\n\nDiscover the perfect blend of comfort and convenience at Parc at West Point, offering an impressive selection of one, two, and three-bedroom floor plans tailored to suit your lifestyle. Revel in a variety of modern finishes, including upgraded kitchens with stainless steel appliances, vaulted ceilings, and private entrances that enhance your living experience. \n\nOur pet-friendly community is designed with amenities that cater to your every need. Enjoy a refreshing dip in our swimming pool, work up a sweat in the fitness center, or unwind in the serene picnic area. Families will appreciate our playground and dog park, while grilling stations and volleyball courts offer fun for everyone.\n\nWith the convenience of flex rent payments and an online resident portal, managing your home has never been easier. Experience peace of mind knowing our dedicated on-site management and 24-hour emergency maintenance are always ready to assist you. Need extra space? Some of our apartments feature spacious finished basements and generous closets, perfect for all your storage needs.\n\nLocated in vibrant North Wales, Parc at West Point invites you to make the most of our community amenities, including high-speed internet access, on-site parking, and serene pond or courtyard views. Whether you prefer a cozy first-floor apartment or a penthouse with breathtaking vistas, we have options to fit every preference.\n\nDon’t miss out on your perfect home! **Find your new home today – browse our availability or schedule a tour to visit our community!** Experience all that Parc at West Point has to offer and elevate your living experience in North Wales!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce04-d2e2-72e4-9bf5-eb8158080fd6.webp",
  "property_featured_image_media": {
    "alt_text": "Swimming pool with lounge chairs and umbrellas",
    "public_id": "019fce04-d2e2-72e4-9bf5-eb8158080fd6",
    "storage_key": "property/6767906449166338/019fce04-d2e2-72e4-9bf5-eb8158080fd6.webp",
    "width": 1920,
    "height": 1282
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "250",
  "property_year_built": "1960",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.8",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "We welcome dogs, cats, and service animals (all must be housebroken; no breeding). Maximum 2 pets per unit. Weight limit: 100 lbs.",
  "property_pet_policy_description": "We welcome dogs, cats, and service animals (all must be housebroken; no breeding). Maximum 2 pets per unit. Weight limit: 100 lbs. One-time pet fee: $350 per pet. Monthly pet rent: $75 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://parcatwestpoint.loftliving.com/login",
  "property_apply_now_url": "https://www.parcatwestpoint.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0268-bd24-7283-9ebc-b66e6e49b830.webp",
  "property_primary_logo_media": {
    "alt_text": "Parc at West Point logo",
    "public_id": "019d0268-bd24-7283-9ebc-b66e6e49b830",
    "storage_key": "property/6767906449166338/019d0268-bd24-7283-9ebc-b66e6e49b830.webp",
    "width": 340,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d026b-8307-7289-892b-8aad93c2c4fc.webp",
  "property_secondary_logo_media": {
    "alt_text": "AI ON MANAGEMENT logo",
    "public_id": "019d026b-8307-7289-892b-8aad93c2c4fc",
    "storage_key": "property/6767906449166338/019d026b-8307-7289-892b-8aad93c2c4fc.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d026b-98ab-70e3-b454-da38c19ae782.webp",
  "property_mono_white_logo_media": {
    "alt_text": "PARC AT WEST POINT logo",
    "public_id": "019d026b-98ab-70e3-b454-da38c19ae782",
    "storage_key": "property/6767906449166338/019d026b-98ab-70e3-b454-da38c19ae782.webp",
    "width": 340,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d026b-a61c-759c-bc26-3cb295b1c64e.webp",
  "property_mono_black_logo_media": {
    "alt_text": "PARC at West Point logo",
    "public_id": "019d026b-a61c-759c-bc26-3cb295b1c64e",
    "storage_key": "property/6767906449166338/019d026b-a61c-759c-bc26-3cb295b1c64e.webp",
    "width": 340,
    "height": 160
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "675 - 1000",
  "property_sqft_min": "675",
  "property_sqft_max": "1000",
  "property_price_range": "1488 - 2170",
  "property_price_min": "1488",
  "property_price_max": "2170",
  "property_available_units": 8,
  "property_facebook_url": "https://www.facebook.com/parcatwestpoint",
  "property_instagram_url": "https://www.instagram.com/parcatwestpoint",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJpfdNTKqjxokRLkUpzj9oeDQ",
  "property_youtube_url": null,
  "property_yelp_url": "https://m.yelp.com/search?find_desc=Apartments&find_loc=North+Wales%2C+PA",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Parc at West Point",
  "property_home_romance_title": "Embrace the Joy of Living in Your Dream Community",
  "property_home_amenities_blurb": "Welcome to Parc at West Point in North Wales, PA, where comfort meets convenience! Choose from beautifully designed one, two, and three-bedroom apartments, featuring modern amenities like stainless steel appliances and private entrances. Enjoy our pet-friendly community with a swimming pool, fitness center, and scenic picnic areas that elevate your living experience.",
  "property_home_floorplans_blurb": "At Parc at West Point in North Wales, PA, your ideal home awaits! Choose from our thoughtfully designed one, two, or three-bedroom floor plans that cater to diverse lifestyles. Elevate your living experience today—browse our available apartment homes and discover where comfort meets convenience!",
  "property_home_gallery_blurb": "At Parc at West Point in North Wales, PA, your ideal home awaits! Choose from spacious one, two, or three-bedroom floor plans adorned with modern amenities like upgraded kitchens, a refreshing swimming pool, and a vibrant dog park. Experience comfort and convenience—picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Parc at West Point, where community meets convenience in North Wales, PA. Enjoy spacious one, two, and three-bedroom apartments, all within reach of vibrant local attractions like parks, theaters, and schools. Discover your perfect home and embrace a lifestyle enriched by nearby gems. Explore your neighborhood today!",
  "property_home_reviews_blurb": "At Parc at West Point in North Wales, PA, residents rave about our friendly, knowledgeable staff and quick maintenance response. One happy tenant shared, “I seriously have no negative issues... Thank you for making this my home for 7 years!” See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Nestled in North Wales, Parc at West Point offers a vibrant lifestyle with top-notch educational institutions and recreational spots nearby. Enjoy easy access to parks, community centers, and cultural highlights like the Ambler Theater and Fort Washington State Park. Dive into local gems and elevate your everyday living experience!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Parc at West Point, where convenience meets comfort! Indulge in our thoughtfully designed one-, two-, and three-bedroom apartments, featuring modern kitchens and private entrances. Unwind at our pet-friendly community, complete with a swimming pool, fitness center, and relaxing picnic area. Experience a lifestyle tailored just for you!",
  "property_applynow_blurb": "At Parc at West Point, North Wales, PA, choose from spacious one, two, or three-bedroom floor plans designed for comfort and style. Enjoy exceptional amenities like a pet-friendly dog park, sparkling swimming pool, and state-of-the-art fitness center, all while relishing the convenience of online leasing. Your ideal home awaits!",
  "property_contactus_blurb": "At Parc at West Point in North Wales, PA, your dream home awaits! Choose from our thoughtfully designed one, two, or three-bedroom floor plans tailored for your lifestyle. Curious about making one yours? Reach out to our leasing team today—we're here to help you find the perfect fit!",
  "property_faqs_blurb": "At Parc at West Point in North Wales, PA, we offer a variety of thoughtfully designed floor plans—one, two, and three bedrooms—tailored to your lifestyle. Have questions? Our FAQs page is the perfect place to find answers about our vibrant community and amenities. Dive in and get informed!",
  "property_floorplans_blurb": "At Parc at West Point in North Wales, PA, your dream home awaits! Choose from our thoughtfully designed one, two, and three-bedroom floor plans, each crafted to enhance your lifestyle. Browse our available apartment homes to find the perfect fit for your unique needs and embrace a vibrant community experience!",
  "property_gallery_blurb": "At Parc at West Point in North Wales, PA, your ideal home awaits! Choose from stylish floor plans, each featuring modern amenities like stainless steel appliances, vaulted ceilings, and private entrances. With a dog park, relaxing pool, and vibrant playground, picture your life thriving in this welcoming community today!",
  "property_interactivemap_blurb": "At Parc at West Point in North Wales, PA, you’ll find spacious one, two, and three-bedroom apartments tailored to your lifestyle. Enjoy pet-friendly amenities, from a dog park to sunny picnics on our sprawling grounds, all while embracing modern comforts like high-speed internet and flexible rent options.",
  "property_pets_blurb": "At Parc at West Point in North Wales, PA, your furry friends can thrive alongside you! With a pet-friendly policy that accommodates up to two pets, your home feels complete. Enjoy spacious living and nearby parks for leisurely strolls—making every day an adventure for both you and your pets.",
  "property_referafriend_blurb": "At Parc at West Point in North Wales, PA, we believe that great friends make great neighbors! With diverse floor plans from one to three bedrooms, there's a perfect space for everyone. Refer a friend today and enhance your community experience—together, you’ll enjoy all the comforts of home!",
  "property_residentaccess_blurb": "At Parc at West Point in North Wales, PA, our diverse floor plans cater to every lifestyle, whether you seek a cozy one-bedroom retreat or a spacious three-bedroom haven. Enhance your living experience by accessing the resident portal for effortless rent payments, maintenance scheduling, and so much more!",
  "property_reviews_blurb": "At Parc at West Point in North Wales, PA, residents rave about our supportive staff and swift maintenance. One cherished member shared, “The maintenance team is great! They seriously get it done.” Join our community where comfort and care make every apartment feel like home. See what our residents have to say!",
  "property_created_at": "1757011121410",
  "property_scheduletour_blurb": "At Parc at West Point in North Wales, PA, our thoughtfully designed one, two, and three-bedroom apartments offer the perfect blend of comfort and style. Experience a vibrant community where modern living meets convenience. Curious about our vibrant lifestyle? Hear directly from our residents and schedule your tour today!",
  "property_thankyou_blurb": "Thank you for your interest in Parc at West Point! Nestled in North Wales, PA, we offer spacious one, two, and three-bedroom floor plans designed for your comfort. Your journey to exceptional living starts now—stay tuned as our team reaches out to you shortly with all the details.",
  "property_virtualtours_blurb": "Experience the perfect blend of comfort and style at Parc at West Point in North Wales, PA. With thoughtfully designed one, two, and three-bedroom floor plans, our community caters to every lifestyle. Immerse yourself in our virtual tour and envision your future home today!",
  "property_copyright": "2025 All Rights Reserved. Parc at West Point",
  "property_seo_title_home": "Parc at West Point |  Apartments in North Wales, PA",
  "property_seo_description_home": "Unwind at Parc at West Point with spacious, pet-friendly living and a vibrant community in North Wales. Experience modern comfort today!",
  "property_seo_title_floorplans": "Floor Plans | North Wales, PA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at Parc at West Point in North Wales, PA. From cozy one-bedroom to spacious three-bedroom layouts, perfect for any lifestyle!",
  "property_seo_title_amenities": "Amenities | North Wales, PA Apartments for Rent",
  "property_seo_description_amenities": "Experience life at Parc at West Point in North Wales, PA. Enjoy upgraded kitchens, a resort-style pool, pet-friendly spaces, and vibrant community activities!",
  "property_seo_title_gallery": "Gallery | Apartments in North Wales, PA",
  "property_seo_description_gallery": "Discover modern living at Parc at West Point: stunning views, upgraded amenities, pet-friendly spaces, and private entrances—check out our gallery!",
  "property_seo_title_virtualtours": "Virtual Tours | Parc at West Point Apartments",
  "property_seo_description_virtualtours": "Step into comfort at Parc at West Point! Take a virtual tour of our stunning one to three-bedroom apartments in North Wales, PA, and envision your new life.",
  "property_seo_title_interactivemap": "Interactive Map | Parc at West Point Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Parc at West Point! Explore spacious 1-3 bedroom apartments with premium amenities using our interactive map.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in North Wales, PA",
  "property_seo_description_neighborhood": "Experience North Wales at Parc at West Point! Uncover local gems and vibrant hotspots just steps away from your new home. Your ideal neighborhood awaits!",
  "property_seo_title_contact": "Contact Us | Parc at West Point",
  "property_seo_description_contact": "Experience comfort at Parc at West Point in North Wales, PA. From cozy one-bedroom to spacious three-bedroom layouts, our team is here to assist!",
  "property_seo_title_faqs": "FAQs | Apartments in North Wales, PA",
  "property_seo_description_faqs": "Get answers to your questions at Parc at West Point in North Wales, PA! Explore amenities, floor plans, and more—everything you need for comfortable living!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in North Wales, PA",
  "property_seo_description_reviews": "Experience life at Parc at West Point in North Wales, PA! Read real resident reviews and see why our community's amenities and charm make it a perfect home.",
  "property_seo_title_applynow": "Apply Now | Apartments in North Wales, PA",
  "property_seo_description_applynow": "Experience refined living at Parc at West Point in North Wales, PA. Choose from stylish one-to-three-bedroom homes with top amenities. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Parc at West Point",
  "property_seo_description_residentaccess": "Access your resident portal at Parc at West Point in North Wales, PA. Pay rent, schedule maintenance, and enjoy hassle-free living at your fingertips!",
  "property_seo_title_referafriend": "Refer A Friend | Parc at West Point",
  "property_seo_description_referafriend": "Refer a friend to Parc at West Point in North Wales, PA, and enjoy vibrant living together. Great friends make great neighbors!",
  "property_seo_title_scheduletour": "Schedule a Tour | Parc at West Point",
  "property_seo_description_scheduletour": "Step into your future home at Parc at West Point! Schedule a tour today and experience luxury living in North Wales, PA, where community meets comfort.",
  "property_seo_title_privacy": "Privacy Policy | Parc at West Point",
  "property_seo_description_privacy": "At Parc at West Point in North Wales, PA, your privacy matters. Learn how we safeguard your information in our detailed privacy policy. View now!",
  "property_seo_title_accessibility": "Website Accessibility | Parc at West Point",
  "property_seo_description_accessibility": "Embrace accessibility at Parc at West Point in North Wales, PA. We champion digital inclusion for all. Your comfortable living experience starts here!",
  "property_seo_title_sitemap": "Sitemap | Parc at West Point",
  "property_seo_description_sitemap": "Navigate your way through Parc at West Point in North Wales, PA. Check our sitemap for easy access to everything you need to know about our vibrant community!",
  "property_seo_title_thankyou": "Thank You | Parc at West Point",
  "property_seo_description_thankyou": "Thank you for reaching out to Parc at West Point! Your inquiry is in good hands, and our team will be in touch soon to help you find your perfect home.",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1791293651586",
  "amenities": [
    {
      "id": "custom_3185d9ae-cac7-4f8f-9184-4b8ee7bfd8d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_29229ff3-19cd-4c62-bb2e-b8c49c6a48a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d3df116d-6138-4ce1-a9d7-32316c19838d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_62b58d5c-5f98-4a21-b642-34268dc15d9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_13d1488c-c2c2-4ca1-a74e-e26f1533d930",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment & Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f91828c7-0228-45a2-9dc2-c91004a2c92a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4dab1bf9-2471-4035-8546-6717d5afd09f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management Office",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c59b11e4-05fe-4f31-9920-e54f7ae81e8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Short Term Leases",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ebec0f09-87c9-43b2-8ccf-1a81eb01309d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Short-Term Leases Available",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_130f3740-09ed-4113-85c8-915fee666a48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Storage Space Available",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ab1b5850-7ac4-43e4-8f11-077e52942ebb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Wi-Fi Available",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e77e2cbb-940d-41d4-bef7-f1b0d35cf1fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d85d960a-b802-473a-8f9d-8487e36be45a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Cable-Ready",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8e652a3c-1ee0-4a41-a54e-7f6216ecb281",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e95c785f-6702-4931-ae83-55598e2cb8a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d9a7eaff-d6da-4072-9794-a740488fa957",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0f6eeeec-f0e2-4869-948f-ec1463be1df9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Hardwood-Like Plank Vinyl Flooring*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_40988fde-a667-417a-9e8a-18468a087527",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "High-Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f6848d33-87c3-4ed3-b46b-d86d784b32cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Private Entrances",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b711d1f7-2abb-4d4a-9018-a5f73ecc2e30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patio or Balcony",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_752c3dc0-0533-4f4d-9dc4-a2caf10cec4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Quarts Countertops*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b56e5884-726b-4562-a741-4a7d15621913",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Apartments*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_17d7ccc5-c219-434a-83dc-b95b8c312716",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c7233831-b8e2-46ae-8bb7-36734b9144cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Subway Tile Backsplash*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f9677dfd-a4eb-42a2-853c-dec5fe333eba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a7985b06-1e73-4c40-8d74-23fb35e3a299",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Wall-to-Wall Carpet",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fecf9a14-bdc9-488c-b5d1-3b3eb961a968",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6b02145d-992d-4891-955c-92e3971e9240",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Close to Septa Regional Rail to Center City",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ab6ac101-7635-4680-b856-aa3b2eafd668",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Located in Sought-After Upper Gwynedd Township",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e3ae3c53-b9f9-4c4e-92b1-9ffc2a5f5985",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Merck West Point Campus Less Than 1 Mile Away",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3ba6f60d-4606-4cc3-9fc9-016e636e5235",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cc1f1c18-4b1a-4569-809c-47b95b94bb14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Free Off-Street Parking",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2b489981-032f-4d01-ad54-25b2d0649e1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling & Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_87dc3bbd-3e09-4de1-8891-f134880dffb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_27665756-3c5b-44ff-91c8-a7a6ccb300bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_56b9c7b2-d68d-495a-8ab0-d192e44df9e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "external_id": "false",
      "title": "Volleyball Court",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_33cc8324-a000-427d-ba61-550b487777ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce04-e1dc-7132-8471-747cdb386608.webp",
      "image_media": {
        "alt_text": "Dining room with a long wooden table and bench, adjacent to a kitchen area.",
        "public_id": "019fce04-e1dc-7132-8471-747cdb386608",
        "storage_key": "property/6767906449166338/019fce04-e1dc-7132-8471-747cdb386608.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Bright, contemporary dining space in an apartment, open to the kitchen with neutral tones and a ceiling fan.",
      "link": "false",
      "alt_text": "Dining area with a long wooden table and bench seating, open to a modern white kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/79d614af6fe2e4f98e8a8401518873d9.webp"
    },
    {
      "id": "custom_e0fe3c89-b282-4d9f-aeaf-2f29b69d0f34",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce04-e218-724f-964c-0c0d15d0579c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and marble backsplash.",
        "public_id": "019fce04-e218-724f-964c-0c0d15d0579c",
        "storage_key": "property/6767906449166338/019fce04-e218-724f-964c-0c0d15d0579c.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring sleek white cabinetry, a stainless steel dishwasher, oven, and refrigerator, complemented by a stylish marble subway tile backsplash.",
      "link": "false",
      "alt_text": "Kitchen in a modern apartment with white cabinets, stainless appliances, and a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/92cec889d047c8e1b7ada3f2c33f360a.jpg"
    },
    {
      "id": "custom_42d0bbae-f8d7-4c57-9d65-a3075317016e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce04-e21a-7668-bdcc-328e28ecd05c.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, and TV.",
        "public_id": "019fce04-e21a-7668-bdcc-328e28ecd05c",
        "storage_key": "property/6767906449166338/019fce04-e21a-7668-bdcc-328e28ecd05c.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Spacious living room with comfortable seating, a large TV, and decorative accents. Perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Living room in a modern apartment with beige sofa, dark wood coffee table, and wall-mounted TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/d09752c720fd8cc59c44f97e76f0eb51.webp"
    },
    {
      "id": "custom_c585c829-e44a-4ee2-8f21-31eafbd075c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce04-e205-71d9-8059-508527da5f9a.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, dresser, and TV.",
        "public_id": "019fce04-e205-71d9-8059-508527da5f9a",
        "storage_key": "property/6767906449166338/019fce04-e205-71d9-8059-508527da5f9a.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, a stylish dresser with a mounted TV, and ample natural light from the large window.",
      "link": "false",
      "alt_text": "Bedroom in an apartment with a large bed, bench at foot, dresser, and window with white curtains.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/6808c5ac98cc17949438ff94de96c338.jpg"
    },
    {
      "id": "custom_d1ee3719-9390-422a-aa33-6635bdcfc15e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce04-ec81-7075-b2b9-237bb956da46.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and dark wood cabinets.",
        "public_id": "019fce04-ec81-7075-b2b9-237bb956da46",
        "storage_key": "property/6767906449166338/019fce04-ec81-7075-b2b9-237bb956da46.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen featuring dark wood cabinetry, white countertops, stainless steel appliances, and a tiled backsplash.",
      "link": "false",
      "alt_text": "Kitchen with dark wood cabinets, stainless steel appliances, and white countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/28096d0e7daa8223bb2079945f4e843c.webp"
    },
    {
      "id": "custom_09a6e9f4-6980-4621-8bfd-13b2ced876fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce04-ecb9-74f2-8592-ef692a3f7fbd.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and white subway tile backsplash.",
        "public_id": "019fce04-ecb9-74f2-8592-ef692a3f7fbd",
        "storage_key": "property/6767906449166338/019fce04-ecb9-74f2-8592-ef692a3f7fbd.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Spacious apartment kitchen with stainless steel appliances, dark cabinetry, and a sleek marble backsplash.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel fridge and appliances, and white marble backsplash.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/de2d300657281e3359486ccd5f5e930b.webp"
    },
    {
      "id": "custom_dae93c7a-0b9d-428f-89a2-ffebcb291389",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce04-ed4a-735e-a591-c59cd400db15.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with stainless steel appliances, dark cabinets, and a round table with chairs.",
        "public_id": "019fce04-ed4a-735e-a591-c59cd400db15",
        "storage_key": "property/6767906449166338/019fce04-ed4a-735e-a591-c59cd400db15.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Enjoy meals in your bright dining area, adjacent to a modern kitchen featuring stainless steel appliances and ample cabinet space.",
      "link": "false",
      "alt_text": "Dining area in a compact apartment with a round glass table, wooden chairs, and stainless appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/16b28bc423bef57b5cc78710f36d695a.webp"
    },
    {
      "id": "custom_1e3ef60b-e52f-4c1d-b00f-333ece0c73fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce04-edcb-70ac-8176-d1a8fcfc73f9.webp",
      "image_media": {
        "alt_text": "A staged living room with a sectional couch, coffee table, and TV.",
        "public_id": "019fce04-edcb-70ac-8176-d1a8fcfc73f9",
        "storage_key": "property/6767906449166338/019fce04-edcb-70ac-8176-d1a8fcfc73f9.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Relax in style in this spacious living room, perfect for entertaining or unwinding after a long day. Features modern furnishings and ample natural light.",
      "link": "false",
      "alt_text": "Living room in an apartment with a sectional sofa, plant, coffee table, and sliding glass door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/be18e392bd344c1f5d61f7b0231394f6.webp"
    },
    {
      "id": "custom_9ab22a45-f583-45c5-af0d-cd6b0202c0fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce04-f7a2-760f-8a82-a4c88ac6f592.webp",
      "image_media": {
        "alt_text": "Living room with dining area and sliding glass door to patio",
        "public_id": "019fce04-f7a2-760f-8a82-a4c88ac6f592",
        "storage_key": "property/6767906449166338/019fce04-f7a2-760f-8a82-a4c88ac6f592.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright, modern apartment living space with an open layout, neutral decor, and a sliding patio door.",
      "link": "false",
      "alt_text": "Open-plan living area with a gray sofa, dining table, and sliding glass doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/5f5522f9efa874a84c79d609b676c925.jpg"
    },
    {
      "id": "custom_05e5645a-c24b-459d-a8ca-e3b755402579",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce04-f814-710b-ba0c-64a1db910653.webp",
      "image_media": {
        "alt_text": "Home office with a desk, chair, computer, and shelving.",
        "public_id": "019fce04-f814-710b-ba0c-64a1db910653",
        "storage_key": "property/6767906449166338/019fce04-f814-710b-ba0c-64a1db910653.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Modern apartment office space with a desk, storage drawers, shelving, and a decorative plant.",
      "link": "false",
      "alt_text": "Bright home office with a white desk, chair, shelving, and a tall plant.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/f3df0603c4a8b242be2d20573b8999da.jpg"
    },
    {
      "id": "custom_6a8c0abb-b250-466d-a855-27dacc3b8bd8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce04-f8e5-725e-8ba7-95c707df86c5.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, dresser, TV, and window.",
        "public_id": "019fce04-f8e5-725e-8ba7-95c707df86c5",
        "storage_key": "property/6767906449166338/019fce04-f8e5-725e-8ba7-95c707df86c5.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Apartment",
      "description": "A modern bedroom with a gray-toned dresser, wall-mounted TV, ceiling fan, and light curtains, showcasing a clean apartment interior.",
      "link": "false",
      "alt_text": "Bedroom with a large bed, gray dresser, wall TV, and sheer curtains.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/08ba5909f08db3e462020431e8eea80f.jpg"
    },
    {
      "id": "custom_1de22720-88a9-4885-8da5-6f7f27366357",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-03b8-753d-a801-50ff5ae36142.webp",
      "image_media": {
        "alt_text": "A staged bedroom featuring a made bed, a dresser, a closet with clothes, and a television on a credenza.",
        "public_id": "019fce05-03b8-753d-a801-50ff5ae36142",
        "storage_key": "property/6767906449166338/019fce05-03b8-753d-a801-50ff5ae36142.webp",
        "width": 2000,
        "height": 1331
      },
      "title": "Apartment",
      "description": "Bright, modern bedroom in an apartment featuring a large bed, open closet, dresser, and wall-mounted TV.",
      "link": "false",
      "alt_text": "Bedroom in apartment with bed, open closet of clothes, dresser, and wall-mounted TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/85df11fcc6e498f478b63dd12f4dbbba.webp"
    },
    {
      "id": "custom_386d1524-f14e-4327-a849-c7184d136816",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-03b0-703e-bbb8-5f83e47c7385.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with a white sink, chrome faucet, and a large illuminated medicine cabinet above.",
        "public_id": "019fce05-03b0-703e-bbb8-5f83e47c7385",
        "storage_key": "property/6767906449166338/019fce05-03b0-703e-bbb8-5f83e47c7385.webp",
        "width": 1335,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Modern bathroom with white countertop sink, dark wood vanity, and mirrored medicine cabinet, showcasing contemporary apartment finishes.",
      "link": "false",
      "alt_text": "Bathroom vanity with white countertop, single sink, bronze faucet, and mirrored cabinet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/03114f9eb129085027410ed0a5e063ca.webp"
    },
    {
      "id": "custom_cf4a96df-00ee-4d9a-b3e3-a0f8df01ef97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-043e-718e-b541-582bc90ede58.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, shower, toilet, and vanity with sink.",
        "public_id": "019fce05-043e-718e-b541-582bc90ede58",
        "storage_key": "property/6767906449166338/019fce05-043e-718e-b541-582bc90ede58.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom featuring a tub/shower, a white vanity, and a wall shelf for toiletries.",
      "link": "false",
      "alt_text": "Bright apartment bathroom with tub/shower, light-gray curtain, toilet, and white vanity.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/df9d65bccd873b7c0d0fd596aab871e0.jpg"
    },
    {
      "id": "custom_3c1b6fc9-85fd-4e6c-824f-0d1dab3e537b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-084e-7344-ac69-8c67a4ef8988.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with a white countertop, silver faucet, and wood accents.",
        "public_id": "019fce05-084e-7344-ac69-8c67a4ef8988",
        "storage_key": "property/6767906449166338/019fce05-084e-7344-ac69-8c67a4ef8988.webp",
        "width": 1315,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Bright, neutral apartment bathroom featuring a white vanity with sink, large mirror, and modern fixtures.",
      "link": "false",
      "alt_text": "White bathroom vanity with sink, mirror, and towel ring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/e4d48c9bf8cdc19ba3d05d5217a0cee9.webp"
    },
    {
      "id": "custom_4bf182e6-a786-4576-aad2-987f3c8acc45",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-0e45-777a-a630-50756fc3a510.webp",
      "image_media": {
        "alt_text": "View of the exterior grounds from a patio, showing apartments and green space.",
        "public_id": "019fce05-0e45-777a-a630-50756fc3a510",
        "storage_key": "property/6767906449166338/019fce05-0e45-777a-a630-50756fc3a510.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Exterior view of a residential courtyard with grassy lawn, brick buildings, and a decorative lattice privacy screen.",
      "link": "false",
      "alt_text": "Ground-level patio with a sliding glass door, brick wall, decorative lattice, and a grassy apartment courtyard.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/8073da283ee2221848c2f9cf6e1236dc.webp"
    },
    {
      "id": "custom_cd85315f-0884-4c5e-aee3-0cc3496e50e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-10dd-72ad-8f78-bbaaeaed6bb7.webp",
      "image_media": {
        "alt_text": "Treadmills, elliptical machines, and weight racks in a fitness center.",
        "public_id": "019fce05-10dd-72ad-8f78-bbaaeaed6bb7",
        "storage_key": "property/6767906449166338/019fce05-10dd-72ad-8f78-bbaaeaed6bb7.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, equipped with cardio machines and free weights.",
      "link": "false",
      "alt_text": "Fitness center with cardio machines and mirrors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/f0406dbfd7b91bea3a7d83ee834d5f99.webp"
    },
    {
      "id": "custom_139ef2c7-61c1-4b66-befa-763ca603e457",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-1351-735d-9f13-28ab7b6cfc12.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and lush green trees under a blue sky.",
        "public_id": "019fce05-1351-735d-9f13-28ab7b6cfc12",
        "storage_key": "property/6767906449166338/019fce05-1351-735d-9f13-28ab7b6cfc12.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by beautiful landscaping and comfortable lounge chairs. Perfect for relaxing on a sunny day.",
      "link": "false",
      "alt_text": "Outdoor community swimming pool with blue water, lounge chairs, and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/29a0d82d45de221c0702af2688783d3b.webp"
    },
    {
      "id": "custom_193130ff-f3c1-42f1-a48b-fce8485cdc09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-140b-76d2-87d8-f91cb42b6c22.webp",
      "image_media": {
        "alt_text": "Cornhole board and lounge chairs by the swimming pool at a multifamily property.",
        "public_id": "019fce05-140b-76d2-87d8-f91cb42b6c22",
        "storage_key": "property/6767906449166338/019fce05-140b-76d2-87d8-f91cb42b6c22.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Outdoor pool and amenities at a residential community, including lounge chairs and a cornhole board.",
      "link": "false",
      "alt_text": "Outdoor apartment community pool area with lounge chairs and a foreground cornhole board.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/d7e6e57ccb2d5eee7b2364cd4756300a.jpg"
    },
    {
      "id": "custom_c54d0e93-2d7e-4b6d-9c66-f7ffc2a9d19d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-1aac-74ef-87ba-4017318dce3e.webp",
      "image_media": {
        "alt_text": "Outdoor picnic table and built-in grill area in front of apartment building.",
        "public_id": "019fce05-1aac-74ef-87ba-4017318dce3e",
        "storage_key": "property/6767906449166338/019fce05-1aac-74ef-87ba-4017318dce3e.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Outdoor community area at a multifamily property featuring a grill, picnic table, and manicured lawn.",
      "link": "false",
      "alt_text": "Exterior brick apartment building with a concrete patio, grill, and picnic table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/e177e8413ddc67abe0dc07b9ac7617af.jpg"
    },
    {
      "id": "custom_4d14b7a5-2adc-4a98-a865-94c3e9f7abb0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-1d2b-71b3-ae5d-6cf1242ac422.webp",
      "image_media": {
        "alt_text": "Covered picnic area with grills and playground in the background.",
        "public_id": "019fce05-1d2b-71b3-ae5d-6cf1242ac422",
        "storage_key": "property/6767906449166338/019fce05-1d2b-71b3-ae5d-6cf1242ac422.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Outdoor community pavilion with BBQ grills, picnic tables, and a nearby playground at the apartment complex.",
      "link": "false",
      "alt_text": "Wooden pavilion with picnic tables and grills at a residential community; playground visible in background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/712a44dd6ae5f9306b8449038ae856b9.jpg"
    },
    {
      "id": "custom_5c4d2bb0-2697-4960-bef2-58630706d2cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-1f9d-740e-a388-a301800fc5c2.webp",
      "image_media": {
        "alt_text": "Playground with slides, monkey bars and climbing net.",
        "public_id": "019fce05-1f9d-740e-a388-a301800fc5c2",
        "storage_key": "property/6767906449166338/019fce05-1f9d-740e-a388-a301800fc5c2.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Community",
      "description": "Image of a community playground at a multifamily property featuring a tall beige slide, climbing frame, and monkey bars.",
      "link": "false",
      "alt_text": "Outdoor playground with beige spiral slide and climbing structure in a residential apartment community.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/c35c723855288515de294b4321c52e5e.webp"
    },
    {
      "id": "custom_9973bb86-14e0-4db7-b07b-98ad763d11b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-1fc6-744f-8b3a-1340b90b68eb.webp",
      "image_media": {
        "alt_text": "Sand volleyball court with a net and playground in the background.",
        "public_id": "019fce05-1fc6-744f-8b3a-1340b90b68eb",
        "storage_key": "property/6767906449166338/019fce05-1fc6-744f-8b3a-1340b90b68eb.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Outdoor community amenities featuring a sand volleyball court, a playground, and expansive green space.",
      "link": "false",
      "alt_text": "Sand volleyball court on a grassy field with a net, trees, and a playground in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/80cab1f8a0b38778b7f57b930a5108ec.webp"
    },
    {
      "id": "custom_00054c52-dd9d-49c6-953d-a2ae0a5cf55b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-279a-719a-9173-d2534ea0be28.webp",
      "image_media": {
        "alt_text": "Fenced dog park with agility equipment and a bench.",
        "public_id": "019fce05-279a-719a-9173-d2534ea0be28",
        "storage_key": "property/6767906449166338/019fce05-279a-719a-9173-d2534ea0be28.webp",
        "width": 1714,
        "height": 1144
      },
      "title": "Community",
      "description": "A dedicated fenced dog park for residents, complete with agility equipment such as ramps, tunnels, and weave poles, as well as a bench for owners.",
      "link": "false",
      "alt_text": "Fenced outdoor community park with a small playground, agility equipment, and a bench.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/a4e38669cddfb1e0496345bec2dc7973.jpg"
    },
    {
      "id": "custom_9141778a-2db0-4932-a8f8-b3c562854488",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-2c3f-77b1-a43b-df234821a652.webp",
      "image_media": {
        "alt_text": "Signage for Parc at West Point apartments with brick buildings and a manicured lawn in the background.",
        "public_id": "019fce05-2c3f-77b1-a43b-df234821a652",
        "storage_key": "property/6767906449166338/019fce05-2c3f-77b1-a43b-df234821a652.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Wide shot of a suburban apartment complex with brick buildings, manicured lawns, and an entrance sign.",
      "link": "false",
      "alt_text": "Exterior view of a brick apartment community along a tree-lined street with a prominent sign in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/d3bc5284a574d0cd4bdbc18cc609b016.webp"
    },
    {
      "id": "custom_18496bf2-e7a9-4b6e-9f5b-f7e55f084f48",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-2c78-7142-a480-7f25e0c200d5.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with surrounding parking lots and green space.",
        "public_id": "019fce05-2c78-7142-a480-7f25e0c200d5",
        "storage_key": "property/6767906449166338/019fce05-2c78-7142-a480-7f25e0c200d5.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Community",
      "description": "Aerial view of a modern apartment community arranged around a central green lawn with trees and perimeter parking.",
      "link": "false",
      "alt_text": "Aerial view of an apartment complex courtyard, with surrounding buildings, trees, and parking.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/9eeb738ed8a9c37f26f414150c16a35e.jpg"
    },
    {
      "id": "custom_79a6fde6-e595-4f69-8379-12ff36f8f87e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-2cfc-726e-8551-03cf99d6a2b6.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property with brick buildings, green lawns, and mature trees under a bright blue sky with white clouds.",
        "public_id": "019fce05-2cfc-726e-8551-03cf99d6a2b6",
        "storage_key": "property/6767906449166338/019fce05-2cfc-726e-8551-03cf99d6a2b6.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Community",
      "description": "Aerial view of a brick apartment community with several buildings, parking lots, and surrounding trees.",
      "link": "false",
      "alt_text": "Aerial view of a suburban apartment community with brick buildings, roads, and green spaces.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/100a630a07df9e141170936a3895221e.jpg"
    },
    {
      "id": "custom_fbd2deb8-2a8c-4e78-b025-f2d3dd5480ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-33a1-7388-903c-8463cf81ccf4.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with manicured lawns and parking lots.",
        "public_id": "019fce05-33a1-7388-903c-8463cf81ccf4",
        "storage_key": "property/6767906449166338/019fce05-33a1-7388-903c-8463cf81ccf4.webp",
        "width": 2000,
        "height": 1123
      },
      "title": "Community",
      "description": "A multi-building apartment community with brick façades, well-kept lawns, and ample parking.",
      "link": "false",
      "alt_text": "Aerial view of brick apartment buildings, parking lots, and green lawns.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/4ce1a52a/dms3rep/multi/5767906449162442/6767906449166338/1a5bb0bba101ebd6b4ee5ee8a05260dc.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_928a7fd9-abb9-4824-a892-1664b3f4e87c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Alice Bakery & Confectionary",
      "poi_type": "Restaurants",
      "poi_address": "129 S Main St, North Wales, PA 19454, USA",
      "poi_short_description": "Bakery and cafe that whips up breads pastries, cakes and lunch staples from scratch, with coffee and friendly service.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-4328-763f-a6a4-b1eed69d8a91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-4328-763f-a6a4-b1eed69d8a91",
        "storage_key": "property/6767906449166338/019fce05-4328-763f-a6a4-b1eed69d8a91.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://alicebakery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2842008450492487057&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alice-bakery--confectionary",
      "poi_latitude": "40.2105971",
      "poi_longitude": "-75.2768397",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 267-613-8380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bbc1-73a8-81e2-935ea53bc4f7",
        "storage_key": "property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5_084QujxokRkVVDzKDXcCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fa590d0c-775d-40d2-a566-4e8dd5974659",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Turning Point of North Wales",
      "poi_type": "Restaurants",
      "poi_address": "1460 Bethlehem Pike, North Wales, PA 19454, USA",
      "poi_short_description": "Daytime cafe chain serving breakfast, sandwiches, tea & coffee drinks in stylish surroundings.",
      "poi_long_description": "Daytime cafe chain serving breakfast, sandwiches, tea & coffee drinks in stylish surroundings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-43e6-7099-8866-38666717def0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-43e6-7099-8866-38666717def0",
        "storage_key": "property/6767906449166338/019fce05-43e6-7099-8866-38666717def0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://turningpointrestaurants.com/location/north-wales/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6781185739571140758&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "turning-point-of-north-wales",
      "poi_latitude": "40.2089593",
      "poi_longitude": "-75.2230651",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 267-462-4564",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bbc1-73a8-81e2-935ea53bc4f7",
        "storage_key": "property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9-mXyV-kxokRlhgVe4CcG14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_133a2e4b-cdad-4e9b-bd6b-68383bcddf8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Tex Mex Connection",
      "poi_type": "Restaurants",
      "poi_address": "201 E Walnut St, North Wales, PA 19454, USA",
      "poi_short_description": "Long-standing (since 1984) eco-friendly choice serving Tex-Mex fare & tequilas in a festive setting.",
      "poi_long_description": "Long-standing (since 1984) eco-friendly choice serving Tex-Mex fare & tequilas in a festive setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-437d-733e-b67e-cf5e74854765.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-437d-733e-b67e-cf5e74854765",
        "storage_key": "property/6767906449166338/019fce05-437d-733e-b67e-cf5e74854765.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.texmexconnection.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8231732961840332452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tex-mex-connection",
      "poi_latitude": "40.2116062",
      "poi_longitude": "-75.2777605",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 215-699-9552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bbc1-73a8-81e2-935ea53bc4f7",
        "storage_key": "property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1wYpZQmjxokRpP5d5IP9PHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9963ab52-ceaa-419e-b489-d56c7cc3286d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Joseph Ambler Inn",
      "poi_type": "Restaurants",
      "poi_address": "1005 Horsham Rd, North Wales, PA 19454, USA",
      "poi_short_description": "Country-chic quarters on an 18th-century farm, plus a casual pub, free breakfast & upmarket dining.",
      "poi_long_description": "Country-chic quarters on an 18th-century farm, plus a casual pub, free breakfast & upmarket dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-435f-76cc-aa9b-37a228f54de0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-435f-76cc-aa9b-37a228f54de0",
        "storage_key": "property/6767906449166338/019fce05-435f-76cc-aa9b-37a228f54de0.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://www.josephamblerinn.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3792032224740381771&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joseph-ambler-inn",
      "poi_latitude": "40.2385419",
      "poi_longitude": "-75.2272587",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 215-362-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bbb4-76c8-be44-b46d5b51972d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bbb4-76c8-be44-b46d5b51972d",
        "storage_key": "property/6767906449166338/019d0269-bbb4-76c8-be44-b46d5b51972d.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJS805fRekxokRSxR8pDcBoDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_403e9529-ae9f-4adc-985d-4ad5510e05a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "The Metropolitan, American Diner & Bar",
      "poi_type": "Restaurants",
      "poi_address": "750 Upper State Rd, North Wales, PA 19454, USA",
      "poi_short_description": "This retro-chic eatery & full bar serves a modern take on diner fare, including breakfast all day.",
      "poi_long_description": "This retro-chic eatery & full bar serves a modern take on diner fare, including breakfast all day.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-48bf-7094-ab26-85ae3293c8a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-48bf-7094-ab26-85ae3293c8a9",
        "storage_key": "property/6767906449166338/019fce05-48bf-7094-ab26-85ae3293c8a9.webp",
        "width": 1024,
        "height": 666
      },
      "poi_business_url": "https://www.metrodinerbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9635088100631317424&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-metropolitan-american-diner--bar",
      "poi_latitude": "40.2387384",
      "poi_longitude": "-75.23538529999999",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-361-1603",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bbc1-73a8-81e2-935ea53bc4f7",
        "storage_key": "property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPRcsEBCkxokRsAu5IZS1toU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a37d6e71-da1e-4232-9f5e-04140e0d8665",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Bonefish Grill",
      "poi_type": "Restaurants",
      "poi_address": "27 Arpt Sq Rd, North Wales, PA 19454, USA",
      "poi_short_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_long_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-49f8-741a-9859-5ec8d113fc13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-49f8-741a-9859-5ec8d113fc13",
        "storage_key": "property/6767906449166338/019fce05-49f8-741a-9859-5ec8d113fc13.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://locations.bonefishgrill.com/pennsylvania/north-wales/27-airport-square?y_source=1_MTU1MDI4NDQtNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=4809176849262449419&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bonefish-grill",
      "poi_latitude": "40.2371945",
      "poi_longitude": "-75.240839",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 215-361-2932",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bbc1-73a8-81e2-935ea53bc4f7",
        "storage_key": "property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_cle3A6kxokRCxNSQt2gvUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_931c7935-0d8c-4121-99c0-70ee55963d40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Shake Shack Montgomeryville",
      "poi_type": "Restaurants",
      "poi_address": "28 Arpt Sq Rd, North Wales, PA 19454, USA",
      "poi_short_description": "Hip, counter-serve chain for gourmet takes on fast-food classics like burgers & frozen custard.",
      "poi_long_description": "Hip, counter-serve chain for gourmet takes on fast-food classics like burgers & frozen custard.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-4ab2-725b-98b8-5d1e5ca62c0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-4ab2-725b-98b8-5d1e5ca62c0f",
        "storage_key": "property/6767906449166338/019fce05-4ab2-725b-98b8-5d1e5ca62c0f.webp",
        "width": 1280,
        "height": 918
      },
      "poi_business_url": "https://shakeshack.com/location/-PA?utm_source=google&utm_medium=listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=14738807905471661878&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shake-shack-montgomeryville",
      "poi_latitude": "40.2377705",
      "poi_longitude": "-75.24132019999999",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 267-651-2113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bbc1-73a8-81e2-935ea53bc4f7",
        "storage_key": "property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmwvyLWqlxokRNodbUrPDisw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_581ea376-e3f6-499a-a09d-fff433b3f3e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "CAVA",
      "poi_type": "Restaurants",
      "poi_address": "32 Arpt Sq Rd, North Wales, PA 19454, USA",
      "poi_short_description": "Mediterranean restaurant for thoughtful food with customizable greens & grains bowls, pitas & salad.",
      "poi_long_description": "Mediterranean restaurant for thoughtful food with customizable greens & grains bowls, pitas & salad.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-4f18-77fa-a5fe-1d114de29a92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-4f18-77fa-a5fe-1d114de29a92",
        "storage_key": "property/6767906449166338/019fce05-4f18-77fa-a5fe-1d114de29a92.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://cava.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1918579629627637785&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cava",
      "poi_latitude": "40.2388734",
      "poi_longitude": "-75.24172999999999",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 267-649-4733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bbc1-73a8-81e2-935ea53bc4f7",
        "storage_key": "property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZyg8XPylxokRGYBBEQIqoBo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1ade25d5-d3ab-410a-986b-f95c62bcf288",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "30 Arpt Sq Rd, North Wales, PA 19454, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-4f2a-7418-898b-79884737e6d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-4f2a-7418-898b-79884737e6d7",
        "storage_key": "property/6767906449166338/019fce05-4f2a-7418-898b-79884737e6d7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.chipotle.com/pa/north-wales/30-airport-square?utm_source=google&utm_medium=yext&utm_campaign=yext_listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=8400591673841548335&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "40.2406709",
      "poi_longitude": "-75.2419064",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 215-368-8740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bbc1-73a8-81e2-935ea53bc4f7",
        "storage_key": "property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT-uq6A6kxokRL_xtfp7llHQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_af22ca00-d01d-456d-af5a-8bd272e18d4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Playa Bowls",
      "poi_type": "Restaurants",
      "poi_address": "4 Arpt Sq Rd, North Wales, PA 19454, USA",
      "poi_short_description": "Casual chain for acai, coconut and pitaya breakfast bowls plus smoothies and cold brew.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-5063-77d3-9f30-376e721acb87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-5063-77d3-9f30-376e721acb87",
        "storage_key": "property/6767906449166338/019fce05-5063-77d3-9f30-376e721acb87.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.playabowls.com/location/montgomeryville",
      "poi_directions_map_url": "https://maps.google.com/?cid=10566272265485670238&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "playa-bowls",
      "poi_latitude": "40.2391983",
      "poi_longitude": "-75.2401739",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 215-589-4878",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bbc1-73a8-81e2-935ea53bc4f7",
        "storage_key": "property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCSXypjOlxokRXtdVmKTwopI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6a01306b-ac39-41cf-a7f4-20e835ad09d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "OOKA Restaurant Bar . Sushi .Hibachi",
      "poi_type": "Restaurants",
      "poi_address": "764 Bethlehem Pike, Montgomeryville, PA 18936, USA",
      "poi_short_description": "Urbane outfit serving up sushi, teppanyaki & other Japanese fare in a spare, wood-accented locale.",
      "poi_long_description": "Urbane outfit serving up sushi, teppanyaki & other Japanese fare in a spare, wood-accented locale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-50fb-7288-b2a5-5f68fa8949ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-50fb-7288-b2a5-5f68fa8949ae",
        "storage_key": "property/6767906449166338/019fce05-50fb-7288-b2a5-5f68fa8949ae.webp",
        "width": 638,
        "height": 424
      },
      "poi_business_url": "http://www.ookasushi.com/tablet/montgomeryville.html#menumm",
      "poi_directions_map_url": "https://maps.google.com/?cid=18338118643673954099&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ooka-restaurant-bar--sushi-hibachi",
      "poi_latitude": "40.2428253",
      "poi_longitude": "-75.2435261",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 215-361-1119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bbc1-73a8-81e2-935ea53bc4f7",
        "storage_key": "property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnUBLXgakxokRM3cnNb8Vfv4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_62847a9b-eee5-4160-9a8a-9792c00abf69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Hibachi Grill Buffet LLC",
      "poi_type": "Restaurants",
      "poi_address": "675 Bethlehem Pike, Montgomeryville, PA 18936, USA",
      "poi_short_description": "Easygoing buffet offering hundreds of Chinese, Japanese & American items, including hibachi.",
      "poi_long_description": "Easygoing buffet offering hundreds of Chinese, Japanese & American items, including hibachi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-5553-7322-a645-1dad4afb42d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-5553-7322-a645-1dad4afb42d5",
        "storage_key": "property/6767906449166338/019fce05-5553-7322-a645-1dad4afb42d5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hibachigrillandbuffet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6167262429219352081&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hibachi-grill-buffet-llc",
      "poi_latitude": "40.2549833",
      "poi_longitude": "-75.2470417",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 215-855-6888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bbc1-73a8-81e2-935ea53bc4f7",
        "storage_key": "property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtSGcFaumxokREW47-oCEllU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_95567401-b797-4000-ae56-78cbbdc27da3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "The Pour House - North Wales",
      "poi_type": "Restaurants",
      "poi_address": "29 Arpt Sq Rd, North Wales, PA 19454, USA",
      "poi_short_description": "Comfort food, including burgers and flatbread, plus a big beer list, in a casual atmosphere.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-5544-7683-84b9-b905a76a032f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-5544-7683-84b9-b905a76a032f",
        "storage_key": "property/6767906449166338/019fce05-5544-7683-84b9-b905a76a032f.webp",
        "width": 600,
        "height": 393
      },
      "poi_business_url": "https://www.pjspourhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16657715580630315928&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-pour-house---north-wales",
      "poi_latitude": "40.2382542",
      "poi_longitude": "-75.24151260000001",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 267-645-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bbc1-73a8-81e2-935ea53bc4f7",
        "storage_key": "property/6767906449166338/019d0269-bbc1-73a8-81e2-935ea53bc4f7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ48oYXgikxokRmLP1cBAYLOc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9dfb66c8-cc6d-4636-a7c9-18ae06b45f6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Redner's Warehouse Markets",
      "poi_type": "Shopping",
      "poi_address": "1200 Welsh Rd Ste 3, North Wales, PA 19454, USA",
      "poi_short_description": "Employee-owned grocery chain known for produce and baked goods, as well as friendly service.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-56a2-762e-a42a-e88b9554583b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-56a2-762e-a42a-e88b9554583b",
        "storage_key": "property/6767906449166338/019fce05-56a2-762e-a42a-e88b9554583b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.rednersmarkets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=504635925108670816&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "redners-warehouse-markets",
      "poi_latitude": "40.228524",
      "poi_longitude": "-75.256991",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 215-393-0603",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bbb5-71a8-b944-1ecf99480867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bbb5-71a8-b944-1ecf99480867",
        "storage_key": "property/6767906449166338/019d0269-bbb5-71a8-b944-1ecf99480867.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJk3ex9I2jxokRYMEAQbPTAAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_78c46a17-383a-42f6-9837-8e3e9f82ab93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "GIANT",
      "poi_type": "Shopping",
      "poi_address": "1201 Knapp Rd, North Wales, PA 19454, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-5711-74d2-a23a-ba3aae1c61ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-5711-74d2-a23a-ba3aae1c61ca",
        "storage_key": "property/6767906449166338/019fce05-5711-74d2-a23a-ba3aae1c61ca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.giantfoodstores.com/store/c754bcb0-f952-11e2-81a7-005056954a3e",
      "poi_directions_map_url": "https://maps.google.com/?cid=14607678082613638463&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "giant",
      "poi_latitude": "40.2275466",
      "poi_longitude": "-75.2404327",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-661-1025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf53-753e-bfb8-869ddc13aa38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf53-753e-bfb8-869ddc13aa38",
        "storage_key": "property/6767906449166338/019d0269-bf53-753e-bfb8-869ddc13aa38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi79MdXOkxokRP_VxQ9LluMo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3c5c9758-04ca-4eef-8553-386304125aec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Wegmans",
      "poi_type": "Shopping",
      "poi_address": "500 Montgomery Mall, North Wales, PA 19454, USA",
      "poi_short_description": "Chain known for its fresh produce, prepared-food selections and bakeries, plus gluten-free goods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-5c13-77a8-bef2-5a1084b047d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-5c13-77a8-bef2-5a1084b047d4",
        "storage_key": "property/6767906449166338/019fce05-5c13-77a8-bef2-5a1084b047d4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wegmans.com/stores/montgomeryville-pa/?cid=GMB_Wegmans_2024:aw:ow:gb:gb:ao::",
      "poi_directions_map_url": "https://maps.google.com/?cid=15915584943918256475&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wegmans",
      "poi_latitude": "40.2347839",
      "poi_longitude": "-75.24468159999999",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 267-677-0700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf53-753e-bfb8-869ddc13aa38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf53-753e-bfb8-869ddc13aa38",
        "storage_key": "property/6767906449166338/019d0269-bf53-753e-bfb8-869ddc13aa38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAeg_xwmkxokRW5HNni6E39w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_00a63370-54d7-41cf-a2c6-21b15ac6a1af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping",
      "poi_address": "740 Upper State Rd, North Wales, PA 19454, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-5bf4-7069-9eb5-e16320fafb1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-5bf4-7069-9eb5-e16320fafb1f",
        "storage_key": "property/6767906449166338/019fce05-5bf4-7069-9eb5-e16320fafb1f.webp",
        "width": 1280,
        "height": 831
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/north-wales-PA-248.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=18425274443893126030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "40.2367886",
      "poi_longitude": "-75.2338694",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 215-353-4153",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bbb5-71a8-b944-1ecf99480867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bbb5-71a8-b944-1ecf99480867",
        "storage_key": "property/6767906449166338/019d0269-bbb5-71a8-b944-1ecf99480867.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJY98jChCkxokRjjNVRXy5s_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_03d8aff1-1eaa-4e45-beb5-6dd09e8423a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping",
      "poi_address": "125 Witchwood Dr, North Wales, PA 19454, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-5cb7-731a-b0bf-a853c18de4bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-5cb7-731a-b0bf-a853c18de4bf",
        "storage_key": "property/6767906449166338/019fce05-5cb7-731a-b0bf-a853c18de4bf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/montgomeryville/1159",
      "poi_directions_map_url": "https://maps.google.com/?cid=10144913333183389358&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "40.2244338",
      "poi_longitude": "-75.239952",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 215-699-5688",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bbb5-71a8-b944-1ecf99480867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bbb5-71a8-b944-1ecf99480867",
        "storage_key": "property/6767906449166338/019d0269-bbb5-71a8-b944-1ecf99480867.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0WVXEHKkxokRrh6FLe34yYw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_570937a5-aaa8-4634-857b-d171b08660c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping",
      "poi_address": "125 Witchwood Dr, North Wales, PA 19454, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-5e16-7158-ac4b-40f97de0f4c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-5e16-7158-ac4b-40f97de0f4c6",
        "storage_key": "property/6767906449166338/019fce05-5e16-7158-ac4b-40f97de0f4c6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cvs.com/store-locator/north-wales-pa-pharmacies/125-witchwood-dr-north-wales-pa-19454/storeid=16521?WT.mc_id=LS_GOOGLE_RX_16521",
      "poi_directions_map_url": "https://maps.google.com/?cid=15628853674604541308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "40.2241891",
      "poi_longitude": "-75.24043139999999",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 215-699-7767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf83-759e-bebe-639f3e70bf7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf83-759e-bebe-639f3e70bf7b",
        "storage_key": "property/6767906449166338/019d0269-bf83-759e-bebe-639f3e70bf7b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0WVXEHKkxokRfLVcoZzX5Ng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0b153e19-4bc7-415e-b7e4-0246952b9b01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping",
      "poi_address": "710 N Wales Rd, North Wales, PA 19454, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-61b8-7689-b33c-3a31fef27935.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-61b8-7689-b33c-3a31fef27935",
        "storage_key": "property/6767906449166338/019fce05-61b8-7689-b33c-3a31fef27935.webp",
        "width": 1280,
        "height": 567
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-710+n+wales+rd-north+wales-pa-19454/id=7196",
      "poi_directions_map_url": "https://maps.google.com/?cid=10686942494654257981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "40.2402712",
      "poi_longitude": "-75.2434462",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-412-8709",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd",
        "storage_key": "property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ0TeIJSlxokRPdvkuJOlT5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_298c20fd-f00a-4f02-94a6-0e9ceaee5fe7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Royal Farms",
      "poi_type": "Shopping",
      "poi_address": "467 N Sumneytown Pike, North Wales, PA 19454, USA",
      "poi_short_description": "Gas-station & convenience-store chain serving breakfast sandwiches, fried chicken & deli items.",
      "poi_long_description": "Gas-station & convenience-store chain serving breakfast sandwiches, fried chicken & deli items.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.royalfarms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9797236415101657857&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "royal-farms",
      "poi_latitude": "40.21660869999999",
      "poi_longitude": "-75.2915765",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 267-613-6032",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bfb0-77f8-95a4-f4d224f4b70f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bfb0-77f8-95a4-f4d224f4b70f",
        "storage_key": "property/6767906449166338/019d0269-bfb0-77f8-95a4-f4d224f4b70f.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ0xEOeaqjxokRAeOnjpzG9oc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2e7bd09d-59e8-4727-ad57-af95b36ee937",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping",
      "poi_address": "791 Horsham Rd, North Wales, PA 19454, USA",
      "poi_short_description": "Convenience chain offering grab-&-go bites & beverages, plus assorted newsstand items.",
      "poi_long_description": "Convenience chain offering grab-&-go bites & beverages, plus assorted newsstand items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-622a-7426-8aad-99822d419750.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-622a-7426-8aad-99822d419750",
        "storage_key": "property/6767906449166338/019fce05-622a-7426-8aad-99822d419750.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.7-eleven.com/locations/pa/north-wales/791-horsham-road-24555?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6768509861954357742&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "40.24540080000001",
      "poi_longitude": "-75.2395882",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-368-2786",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bfb0-77f8-95a4-f4d224f4b70f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bfb0-77f8-95a4-f4d224f4b70f",
        "storage_key": "property/6767906449166338/019d0269-bfb0-77f8-95a4-f4d224f4b70f.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJv-b3hAOkxokR7omEvNuT7l0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_14559f78-9858-4167-83f8-e11a82aad383",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping",
      "poi_address": "751 Horsham Rd, Lansdale, PA 19446, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-6333-744f-a82d-87109023f2b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-6333-744f-a82d-87109023f2b7",
        "storage_key": "property/6767906449166338/019fce05-6333-744f-a82d-87109023f2b7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.homedepot.com/l/Montgomeryville/PA/Lansdale/19446/4104?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=12891107650280216501&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "40.2476253",
      "poi_longitude": "-75.23942559999999",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-393-8180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bbb5-71a8-b944-1ecf99480867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bbb5-71a8-b944-1ecf99480867",
        "storage_key": "property/6767906449166338/019d0269-bbb5-71a8-b944-1ecf99480867.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJv_1JVQKkxokRtddFoBtq5rI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dcaa1420-169c-4bdd-a940-ded60d147508",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Gwynedd Square Elementary School",
      "poi_type": "Education",
      "poi_address": "1641 Supplee Rd, Lansdale, PA 19446, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-6860-7428-8c7e-1060c02acb03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-6860-7428-8c7e-1060c02acb03",
        "storage_key": "property/6767906449166338/019fce05-6860-7428-8c7e-1060c02acb03.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://gwyneddsquare.npenn.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14223489795610409509&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gwynedd-square-elementary-school",
      "poi_latitude": "40.22251989999999",
      "poi_longitude": "-75.30945539999999",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-855-4331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c55b-7726-a540-6c31c11f8fb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c55b-7726-a540-6c31c11f8fb7",
        "storage_key": "property/6767906449166338/019d0269-c55b-7726-a540-6c31c11f8fb7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVxKkC1mixokRJXrAHZz8Y8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c73a1361-d7e8-4515-9b66-604d26e9da6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Penndale Middle School",
      "poi_type": "Education",
      "poi_address": "400 Penn St, Lansdale, PA 19446, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-698f-711c-a5fd-85feded100a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-698f-711c-a5fd-85feded100a0",
        "storage_key": "property/6767906449166338/019fce05-698f-711c-a5fd-85feded100a0.webp",
        "width": 867,
        "height": 426
      },
      "poi_business_url": "https://penndale.npenn.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7010288100067389564&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "penndale-middle-school",
      "poi_latitude": "40.23542399999999",
      "poi_longitude": "-75.2786988",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-368-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c55b-7726-a540-6c31c11f8fb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c55b-7726-a540-6c31c11f8fb7",
        "storage_key": "property/6767906449166338/019d0269-c55b-7726-a540-6c31c11f8fb7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrcKjbMejxokRfDCqieKLSWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_555443f8-e944-4895-b332-48aed90f59a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "North Penn High School",
      "poi_type": "Education",
      "poi_address": "1340 S Valley Forge Rd, Lansdale, PA 19446, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-6b57-712e-a43d-7d5d754b68b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-6b57-712e-a43d-7d5d754b68b3",
        "storage_key": "property/6767906449166338/019fce05-6b57-712e-a43d-7d5d754b68b3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nphs.npenn.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8869376812205650401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-penn-high-school",
      "poi_latitude": "40.2347666",
      "poi_longitude": "-75.315446",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 215-368-9800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c55b-7726-a540-6c31c11f8fb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c55b-7726-a540-6c31c11f8fb7",
        "storage_key": "property/6767906449166338/019d0269-c55b-7726-a540-6c31c11f8fb7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJicKWPUKixokR4bGa_jdbFns",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_aa4e5165-114e-44fd-848c-e924d59062ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "North Wales KinderCare",
      "poi_type": "Education",
      "poi_address": "425 N Sumneytown Pike, North Wales, PA 19454, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-6d8f-73f4-9d25-4b49cc570b9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-6d8f-73f4-9d25-4b49cc570b9d",
        "storage_key": "property/6767906449166338/019fce05-6d8f-73f4-9d25-4b49cc570b9d.webp",
        "width": 680,
        "height": 510
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/north-wales/pa/301613?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_NTA3OTkxLTcxNS1sb2NhdGlvbi53ZWJzaXRl",
      "poi_directions_map_url": "https://maps.google.com/?cid=3664193304214542853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-wales-kindercare",
      "poi_latitude": "40.212913",
      "poi_longitude": "-75.287167",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 215-699-7009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c55b-7726-a540-6c31c11f8fb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c55b-7726-a540-6c31c11f8fb7",
        "storage_key": "property/6767906449166338/019d0269-c55b-7726-a540-6c31c11f8fb7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFxv9JgejxokRBZoSfmXU2TI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0d23d939-51ba-4ea4-92cb-1411b91a1fe5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Corpus Christi Catholic School",
      "poi_type": "Education",
      "poi_address": "920 Sumneytown Pike, Lansdale, PA 19446, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-6e0e-7712-ac7a-aa009059ddf5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-6e0e-7712-ac7a-aa009059ddf5",
        "storage_key": "property/6767906449166338/019fce05-6e0e-7712-ac7a-aa009059ddf5.webp",
        "width": 820,
        "height": 360
      },
      "poi_business_url": "https://ccslansdale.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6637441399840110390&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corpus-christi-catholic-school",
      "poi_latitude": "40.2260055",
      "poi_longitude": "-75.3105468",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-368-0582",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c55b-7726-a540-6c31c11f8fb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c55b-7726-a540-6c31c11f8fb7",
        "storage_key": "property/6767906449166338/019d0269-c55b-7726-a540-6c31c11f8fb7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEV0TqFuixokRNvfwVsntHFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d27c0c71-bbc8-4895-b6c4-c74164559233",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Calvary Baptist School",
      "poi_type": "Education",
      "poi_address": "1380 S Valley Forge Rd, Lansdale, PA 19446, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-6fdc-77cc-a055-e3a068d4a4f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-6fdc-77cc-a055-e3a068d4a4f1",
        "storage_key": "property/6767906449166338/019fce05-6fdc-77cc-a055-e3a068d4a4f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cbschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16495480063265399967&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "calvary-baptist-school",
      "poi_latitude": "40.2317867",
      "poi_longitude": "-75.3137804",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-368-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c55b-7726-a540-6c31c11f8fb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c55b-7726-a540-6c31c11f8fb7",
        "storage_key": "property/6767906449166338/019d0269-c55b-7726-a540-6c31c11f8fb7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJd8AYa0OixokRn-R4gri36-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2fc6d034-9c5e-4200-ac89-dd2fe1c1136d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Gwynedd Mercy University",
      "poi_type": "Education",
      "poi_address": "1325 Sumneytown Pike, Gwynedd Valley, PA 19437, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-7302-70da-af16-1046c96e564c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-7302-70da-af16-1046c96e564c",
        "storage_key": "property/6767906449166338/019fce05-7302-70da-af16-1046c96e564c.webp",
        "width": 1280,
        "height": 815
      },
      "poi_business_url": "https://www.gmercyu.edu/?utm_source=google&utm_medium=organic&utm_campaign=gmbmain",
      "poi_directions_map_url": "https://maps.google.com/?cid=4817100659531784388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gwynedd-mercy-university",
      "poi_latitude": "40.1979262",
      "poi_longitude": "-75.2368884",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 215-646-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c55b-7726-a540-6c31c11f8fb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c55b-7726-a540-6c31c11f8fb7",
        "storage_key": "property/6767906449166338/019d0269-c55b-7726-a540-6c31c11f8fb7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk_AnaIGexokRxCCxGofH2UI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_551d0394-d159-4cc1-aeca-a9cb5ad028ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "McAllister Brewing Company",
      "poi_type": "Entertainment",
      "poi_address": "810 Dickerson Rd, North Wales, PA 19454, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-73de-73dd-914c-56ffbd3e2baf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-73de-73dd-914c-56ffbd3e2baf",
        "storage_key": "property/6767906449166338/019fce05-73de-73dd-914c-56ffbd3e2baf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mcallisterbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17414822922387051180&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcallister-brewing-company",
      "poi_latitude": "40.2203069",
      "poi_longitude": "-75.2794581",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 267-655-4918",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd",
        "storage_key": "property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv4kmKaSjxokRrNI1Iy7hrfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0b4365d7-588e-4d6e-9e95-0ccf894fd694",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Ten7 Brewing Company",
      "poi_type": "Entertainment",
      "poi_address": "510 Beaver St, North Wales, PA 19454, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-73e7-729a-b84a-f20c475401cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-73e7-729a-b84a-f20c475401cd",
        "storage_key": "property/6767906449166338/019fce05-73e7-729a-b84a-f20c475401cd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.ten7brewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9284758629928060891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ten7-brewing-company",
      "poi_latitude": "40.2159264",
      "poi_longitude": "-75.2767633",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 717-710-2739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd",
        "storage_key": "property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKxnXjBGjxokR28ca-scW2oA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6536983d-66a4-4230-8762-5c03d666834b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "The Little Pod",
      "poi_type": "Entertainment",
      "poi_address": "1218 Welsh Rd a, North Wales, PA 19454, USA",
      "poi_short_description": "Family-friendly spot with an arcade, slides, a bounce house and a cafe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-7786-7309-b823-b27ccb782264.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-7786-7309-b823-b27ccb782264",
        "storage_key": "property/6767906449166338/019fce05-7786-7309-b823-b27ccb782264.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thelittlepod.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=38626695746172023&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-little-pod",
      "poi_latitude": "40.2269776",
      "poi_longitude": "-75.2563845",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 267-263-2629",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd",
        "storage_key": "property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy6Umg46jxokRdzTMbsY6iQA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3c2d4ef7-7529-4a88-874f-4dbff9a4d52b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Nor-Gwyn Pool",
      "poi_type": "Entertainment",
      "poi_address": "1 Parkside Pl, North Wales, PA 19454, USA",
      "poi_short_description": "Community pool with a 10-lane, 50-meter L-shaped pool, plus a diving board and volleyball court.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-792b-7152-8d72-41ce4469bcd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-792b-7152-8d72-41ce4469bcd0",
        "storage_key": "property/6767906449166338/019fce05-792b-7152-8d72-41ce4469bcd0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://norgwynpool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15387062703651548607&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nor-gwyn-pool",
      "poi_latitude": "40.2093901",
      "poi_longitude": "-75.28766139999999",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 215-699-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd",
        "storage_key": "property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqZvXAQSjxokRv-3POwHUidU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_067064c4-62be-4160-a370-d2f1e98a7948",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Byers' Choice LTD.",
      "poi_type": "Entertainment",
      "poi_address": "4355 County Line Rd, Chalfont, PA 18914, USA",
      "poi_short_description": "Christmas-themed attraction showcasing handcrafted dolls and figurines in traditional scenes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-7aa5-700b-9b63-2d9691069241.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-7aa5-700b-9b63-2d9691069241",
        "storage_key": "property/6767906449166338/019fce05-7aa5-700b-9b63-2d9691069241.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://byerschoice.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=584278950493741003&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "byers-choice-ltd",
      "poi_latitude": "40.2723279",
      "poi_longitude": "-75.2356051",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 215-822-7707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bbb5-71a8-b944-1ecf99480867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bbb5-71a8-b944-1ecf99480867",
        "storage_key": "property/6767906449166338/019d0269-bbb5-71a8-b944-1ecf99480867.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8SImasimxokRy9_qHZzGGwg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_15dee099-2294-4a8f-bbcf-c0b29c2708fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Ambler Theater",
      "poi_type": "Entertainment",
      "poi_address": "108 E Butler Ave, Ambler, PA 19002, USA",
      "poi_short_description": "Nonprofit movie theater specializes in art & foreign films, plus kids' events & guest lecturers.",
      "poi_long_description": "Nonprofit movie theater specializes in art & foreign films, plus kids' events & guest lecturers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-7a58-751b-b3d0-994429f4c1f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-7a58-751b-b3d0-994429f4c1f4",
        "storage_key": "property/6767906449166338/019fce05-7a58-751b-b3d0-994429f4c1f4.webp",
        "width": 1200,
        "height": 675
      },
      "poi_business_url": "http://www.amblertheater.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4797157128645830130&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ambler-theater",
      "poi_latitude": "40.1546417",
      "poi_longitude": "-75.2210857",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 215-345-7855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c556-72a1-95fa-eadd06bb4074.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c556-72a1-95fa-eadd06bb4074",
        "storage_key": "property/6767906449166338/019d0269-c556-72a1-95fa-eadd06bb4074.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJbexoBzm7xokR8uWq-P3skkI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f3236e30-d08f-4016-adae-9f45bd6a1a1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Sellersville Theater",
      "poi_type": "Entertainment",
      "poi_address": "24 W Temple Ave, Sellersville, PA 18960, USA",
      "poi_short_description": "Historic, intimate performing arts venue for live music & comedy shows by local & national acts.",
      "poi_long_description": "Historic, intimate performing arts venue for live music & comedy shows by local & national acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-7e1d-71c6-8f72-f63f91ffc317.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-7e1d-71c6-8f72-f63f91ffc317",
        "storage_key": "property/6767906449166338/019fce05-7e1d-71c6-8f72-f63f91ffc317.webp",
        "width": 1280,
        "height": 823
      },
      "poi_business_url": "https://www.st94.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11128944937910025054&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sellersville-theater",
      "poi_latitude": "40.35933259999999",
      "poi_longitude": "-75.3115239",
      "poi_miles_from_property": "11.7",
      "poi_walking_minutes": "4 hours 18 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 215-257-5808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd",
        "storage_key": "property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO_5zqbgfxIkRXjsCFXX0cZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_da16cef4-3cbd-4b17-ab29-4a9d23418774",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Keswick Theatre",
      "poi_type": "Entertainment",
      "poi_address": "291 N Keswick Ave, Glenside, PA 19038, USA",
      "poi_short_description": "Built in 1928 as a vaudeville/movie theater, this 1,300-seat space now hosts diverse music acts.",
      "poi_long_description": "Built in 1928 as a vaudeville/movie theater, this 1,300-seat space now hosts diverse music acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-800f-761e-9df4-f9e2debd3bc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-800f-761e-9df4-f9e2debd3bc9",
        "storage_key": "property/6767906449166338/019fce05-800f-761e-9df4-f9e2debd3bc9.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "http://www.keswicktheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15835453283059281234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "keswick-theatre",
      "poi_latitude": "40.1063448",
      "poi_longitude": "-75.14718959999999",
      "poi_miles_from_property": "12.8",
      "poi_walking_minutes": "4 hours 43 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 215-572-7650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd",
        "storage_key": "property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0aLkPZuwxokRUq0KctzUwts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_74556470-d5b3-48e2-85b7-2bbe13629405",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Flagship Cinemas Water Tower",
      "poi_type": "Entertainment",
      "poi_address": "750 Montgomery Glen Dr, Montgomeryville, PA 18936, USA",
      "poi_short_description": "Neighborhood standby showing new movies with stadium seating, plus rewards for frequent guests.",
      "poi_long_description": "Neighborhood standby showing new movies with stadium seating, plus rewards for frequent guests.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-81db-74b8-a709-61b8a29ac3f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-81db-74b8-a709-61b8a29ac3f1",
        "storage_key": "property/6767906449166338/019fce05-81db-74b8-a709-61b8a29ac3f1.webp",
        "width": 1280,
        "height": 830
      },
      "poi_business_url": "https://watertower.flagshipcinemas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17321074170515971472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flagship-cinemas-water-tower",
      "poi_latitude": "40.2486075",
      "poi_longitude": "-75.2394702",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-855-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c556-72a1-95fa-eadd06bb4074.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c556-72a1-95fa-eadd06bb4074",
        "storage_key": "property/6767906449166338/019d0269-c556-72a1-95fa-eadd06bb4074.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJKfwgLiilxokRkF3M5S_RYPA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b0d44913-6de3-4652-81e7-9edb6ccdee44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Hatfield Ice Arena",
      "poi_type": "Entertainment",
      "poi_address": "350 County Line Rd, Colmar, PA 18915, USA",
      "poi_short_description": "Spacious year-round venue providing 2 ice-skating & hockey rinks, lessons, party rooms & events.",
      "poi_long_description": "Spacious year-round venue providing 2 ice-skating & hockey rinks, lessons, party rooms & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-82e2-7418-bc18-07df56b40b59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-82e2-7418-bc18-07df56b40b59",
        "storage_key": "property/6767906449166338/019fce05-82e2-7418-bc18-07df56b40b59.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.hatfieldice.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8720096036242492228&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hatfield-ice-arena",
      "poi_latitude": "40.2798182",
      "poi_longitude": "-75.2553708",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 215-997-9797",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd",
        "storage_key": "property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnfe87TGhxokRRIuG1yQBBHk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2d7cc47e-435a-492d-af83-73501ddc12d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Jefferson Lansdale Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "100 Medical Campus Dr, Lansdale, PA 19446, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-8430-75ed-bb4a-f04f304afd0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-8430-75ed-bb4a-f04f304afd0e",
        "storage_key": "property/6767906449166338/019fce05-8430-75ed-bb4a-f04f304afd0e.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.jeffersonhealth.org/locations/jefferson-lansdale-hospital?utm_source=google&utm_medium=organic&utm_campaign=gbp-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1996463513549832306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jefferson-lansdale-hospital",
      "poi_latitude": "40.2504115",
      "poi_longitude": "-75.2714216",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 215-368-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c558-713a-995f-c7b91e92bf7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c558-713a-995f-c7b91e92bf7e",
        "storage_key": "property/6767906449166338/019d0269-c558-713a-995f-c7b91e92bf7e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJs50JId6jxokRcoAq5PzctBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bb1f6bdb-72d3-4555-a700-7011ae1e1b49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "AFC Urgent Care Lansdale",
      "poi_type": "Health and Wellness",
      "poi_address": "1551 S Valley Forge Rd SUITE 3, Lansdale, PA 19446, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-864a-744e-9de9-a7170da3039b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-864a-744e-9de9-a7170da3039b",
        "storage_key": "property/6767906449166338/019fce05-864a-744e-9de9-a7170da3039b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.afcurgentcare.com/lansdale/?utm_source=gmb&utm_medium=organic&utm_campaign=afc-lansdale-gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=7638191708068547673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "afc-urgent-care-lansdale",
      "poi_latitude": "40.2297798",
      "poi_longitude": "-75.3118013",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 267-645-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd",
        "storage_key": "property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_7M1r0SixokRWYzCveNOAGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_25ed2c11-2237-421c-a313-d9612f5e78e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "125 Witchwood Dr, North Wales, PA 19454, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-5e16-7158-ac4b-40f97de0f4c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-5e16-7158-ac4b-40f97de0f4c6",
        "storage_key": "property/6767906449166338/019fce05-5e16-7158-ac4b-40f97de0f4c6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cvs.com/store-locator/north-wales-pa-pharmacies/125-witchwood-dr-north-wales-pa-19454/storeid=16521?WT.mc_id=LS_GOOGLE_RX_16521",
      "poi_directions_map_url": "https://maps.google.com/?cid=15628853674604541308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "40.2241891",
      "poi_longitude": "-75.24043139999999",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 215-699-7767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf83-759e-bebe-639f3e70bf7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf83-759e-bebe-639f3e70bf7b",
        "storage_key": "property/6767906449166338/019d0269-bf83-759e-bebe-639f3e70bf7b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0WVXEHKkxokRfLVcoZzX5Ng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_865b32f9-1f81-4263-8513-be4dc266ab79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "710 N Wales Rd, North Wales, PA 19454, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-8868-733f-b6ff-966462143ab3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-8868-733f-b6ff-966462143ab3",
        "storage_key": "property/6767906449166338/019fce05-8868-733f-b6ff-966462143ab3.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-710+n+wales+rd-north+wales-pa-19454/id=7196",
      "poi_directions_map_url": "https://maps.google.com/?cid=7845652310212645126&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "40.24030279999999",
      "poi_longitude": "-75.24363819999999",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-412-8709",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf83-759e-bebe-639f3e70bf7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf83-759e-bebe-639f3e70bf7b",
        "storage_key": "property/6767906449166338/019d0269-bf83-759e-bebe-639f3e70bf7b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0Y5JQxmjxokRBpFyRTVb4Ww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8f55bc8d-ec87-4d07-9b38-d669d17666ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "North Wales Family Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "107 S Main St, North Wales, PA 19454, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11907519266539266299&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-wales-family-pharmacy",
      "poi_latitude": "40.2109506",
      "poi_longitude": "-75.2777784",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf83-759e-bebe-639f3e70bf7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf83-759e-bebe-639f3e70bf7b",
        "storage_key": "property/6767906449166338/019d0269-bf83-759e-bebe-639f3e70bf7b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__8zXQmjxokR-2AxJq8BQKU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3b86312e-e421-4bbd-b1e4-c23d5227e78e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "751 Horsham Rd, Lansdale, PA 19446, USA",
      "poi_short_description": "Part of a national chain, this gym inside Water Tower Square Shopping Center features a range of cardio and weightlifting equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-8901-713d-a9e3-a14a90676e36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-8901-713d-a9e3-a14a90676e36",
        "storage_key": "property/6767906449166338/019fce05-8901-713d-a9e3-a14a90676e36.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/montgomeryville-horsham-rd-pa?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=5555199461489910432&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "40.2469943",
      "poi_longitude": "-75.24163209999999",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 267-421-5443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd",
        "storage_key": "property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5-oR7gOkxokRoCKMPnoIGE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9e90b5d8-baf6-4a3b-b74a-839357e7fb28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "120 Garden Golf Blvd, North Wales, PA 19454, USA",
      "poi_short_description": "Modern health club chain featuring strength-training gear and cardio equipment, plus a swimming pool, a hot tub and a basketball court. Fitness classes are available.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-8ac8-7354-958f-ba54b260bd10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-8ac8-7354-958f-ba54b260bd10",
        "storage_key": "property/6767906449166338/019fce05-8ac8-7354-958f-ba54b260bd10.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=194&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=12118279243139156831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "40.2347548",
      "poi_longitude": "-75.2355901",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-361-6133",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd",
        "storage_key": "property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLaj7vg2kxokRX4tMKMTGLKg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f691147e-8d05-4d75-90b8-76196effa096",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1210 Bethlehem Pike A5, North Wales, PA 19454, USA",
      "poi_short_description": "Chain fitness center offering group cardio and strength training workouts, with real-time tracking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-8d6a-73a9-9d21-03651308b2b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-8d6a-73a9-9d21-03651308b2b3",
        "storage_key": "property/6767906449166338/019fce05-8d6a-73a9-9d21-03651308b2b3.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/north-wales-pennsylvania-0343?utm_medium=seo&utm_source=gg&utm_term=tombras&utm_campaign=reputationdotcom--National",
      "poi_directions_map_url": "https://maps.google.com/?cid=1164743219697694307&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "40.2084148",
      "poi_longitude": "-75.2259869",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-643-2033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd",
        "storage_key": "property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8SBUuoqkxokRYzagiMn_KRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_74ba40ea-b15f-4bc6-ac47-fd7bb9ee2184",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Kindred Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "1364 Welsh Rd #B104, North Wales, PA 19454, USA",
      "poi_short_description": "Relaxed and bright yoga studio for all levels featuring an uplifting staff and a variety of classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-8ea5-776d-85cd-0fc8389114f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-8ea5-776d-85cd-0fc8389114f9",
        "storage_key": "property/6767906449166338/019fce05-8ea5-776d-85cd-0fc8389114f9.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.kindredyogastudio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18026617889787940406&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kindred-yoga",
      "poi_latitude": "40.2130245",
      "poi_longitude": "-75.2336401",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 267-810-7482",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c55b-7726-a540-6c31c11f8fb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c55b-7726-a540-6c31c11f8fb7",
        "storage_key": "property/6767906449166338/019d0269-c55b-7726-a540-6c31c11f8fb7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDdqBppyQxokRNg6DLnZpK_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_750e5399-4967-42aa-a340-75883d3e084e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Lansdale Area Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "608 E Main St, Lansdale, PA 19446, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-8fcd-701c-b225-1b6ea0a4c446.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-8fcd-701c-b225-1b6ea0a4c446",
        "storage_key": "property/6767906449166338/019fce05-8fcd-701c-b225-1b6ea0a4c446.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.northpennymca.org/our-locations/lansdale-area-family-ymca/?utm_source=google&utm_medium=local&utm_campaign=gbp_L_location",
      "poi_directions_map_url": "https://maps.google.com/?cid=4476614748358919497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lansdale-area-family-ymca",
      "poi_latitude": "40.23386",
      "poi_longitude": "-75.2733154",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-368-1601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd",
        "storage_key": "property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLbdPb8CjxokRSUU1QGUhID4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6c8a48bd-fdd3-4aec-b825-b0b6cdcdd257",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Parkside Place Park",
      "poi_type": "Recreation",
      "poi_address": "1 Parkside Pl, North Wales, PA 19454, USA",
      "poi_short_description": "Friendly park featuring an expansive, castle-themed playground, plus basketball and tennis courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-92d7-700c-b9e8-1c04b950d0a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-92d7-700c-b9e8-1c04b950d0a5",
        "storage_key": "property/6767906449166338/019fce05-92d7-700c-b9e8-1c04b950d0a5.webp",
        "width": 1080,
        "height": 609
      },
      "poi_business_url": "https://www.uppergwynedd.org/parks-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=9854498973588523429&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parkside-place-park",
      "poi_latitude": "40.21056900000001",
      "poi_longitude": "-75.2856941",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 215-699-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c559-709c-a128-4245591d8de8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c559-709c-a128-4245591d8de8",
        "storage_key": "property/6767906449166338/019d0269-c559-709c-a128-4245591d8de8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHernNwSjxokRpQky6Jo2wog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_60c3c6e3-99f5-4992-8682-8fcec97003ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Friendship Park",
      "poi_type": "Recreation",
      "poi_address": "200 Enclave Blvd, North Wales, PA 19454, USA",
      "poi_short_description": "Large playground for little and big kids with a variety of attractions, as well as shaded areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-9550-77cc-8cce-350e30b78a88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-9550-77cc-8cce-350e30b78a88",
        "storage_key": "property/6767906449166338/019fce05-9550-77cc-8cce-350e30b78a88.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.montgomerytwp.org/eGov/apps/locations/facilities.egov?view=detail&id=28",
      "poi_directions_map_url": "https://maps.google.com/?cid=5122252543777652917&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "friendship-park",
      "poi_latitude": "40.2147921",
      "poi_longitude": "-75.2235235",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 215-393-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c559-709c-a128-4245591d8de8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c559-709c-a128-4245591d8de8",
        "storage_key": "property/6767906449166338/019d0269-c559-709c-a128-4245591d8de8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdRJSpkClxokRtUC1uYzlFUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_72e8efca-4935-44b9-8653-e6c4e816df2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Montgomery Township Bark Park",
      "poi_type": "Recreation",
      "poi_address": "1228 Welsh Rd, North Wales, PA 19454, USA",
      "poi_short_description": "Relaxed dog park featuring fenced sections for small and large breeds, plus picnic tables and toys.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-959c-7609-80ed-bd1118963bd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-959c-7609-80ed-bd1118963bd3",
        "storage_key": "property/6767906449166338/019fce05-959c-7609-80ed-bd1118963bd3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.montgomerytwp.org/egov/apps/locations/facilities.egov?view=detail&id=27",
      "poi_directions_map_url": "https://maps.google.com/?cid=8117475079189563542&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "montgomery-township-bark-park",
      "poi_latitude": "40.2257733",
      "poi_longitude": "-75.251908",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-393-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c559-709c-a128-4245591d8de8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c559-709c-a128-4245591d8de8",
        "storage_key": "property/6767906449166338/019d0269-c559-709c-a128-4245591d8de8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJV01kW4mjxokRlgguiJMQp3A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2128bd4f-986b-4b8c-ba3b-2811eccd5f44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Whispering Pines Park",
      "poi_type": "Recreation",
      "poi_address": "200 Orchard Dr, North Wales, PA 19454, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-9682-705c-83cb-1bc8fce52421.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-9682-705c-83cb-1bc8fce52421",
        "storage_key": "property/6767906449166338/019fce05-9682-705c-83cb-1bc8fce52421.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1926204886828503632&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whispering-pines-park",
      "poi_latitude": "40.2313306",
      "poi_longitude": "-75.2292219",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c559-709c-a128-4245591d8de8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c559-709c-a128-4245591d8de8",
        "storage_key": "property/6767906449166338/019d0269-c559-709c-a128-4245591d8de8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2zPwZM2lxokRUNIInCNBuxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_957801ae-6458-4dda-9f72-9c532070a65c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Spring Valley Park Playground",
      "poi_type": "Recreation",
      "poi_address": "1411 Upper State Rd, North Wales, PA 19454, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-99ee-7374-979f-6e39b24bf9d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-99ee-7374-979f-6e39b24bf9d1",
        "storage_key": "property/6767906449166338/019fce05-99ee-7374-979f-6e39b24bf9d1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.montgomerytwp.org/department/?structureid=9",
      "poi_directions_map_url": "https://maps.google.com/?cid=6465971551138144947&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-valley-park-playground",
      "poi_latitude": "40.2532321",
      "poi_longitude": "-75.2200101",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd",
        "storage_key": "property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-1bMwJOnxokRs-JeGd6-u1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e234e6b8-262f-4d7b-8000-42bec18f7f0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Natural Lands' Gwynedd Preserve",
      "poi_type": "Recreation",
      "poi_address": "547 South Swedesford Rd, North Wales, PA 19454, USA",
      "poi_short_description": "Large, peaceful preserve for walking and hiking, home to an array of local wildlife.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-9c0d-72ad-99a8-0c96c9939946.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-9c0d-72ad-99a8-0c96c9939946",
        "storage_key": "property/6767906449166338/019fce05-9c0d-72ad-99a8-0c96c9939946.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://natlands.org/gwynedd-wildlife-preserve/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11087730939822092805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "natural-lands-gwynedd-preserve",
      "poi_latitude": "40.1921633",
      "poi_longitude": "-75.2726378",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 610-353-5587",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c559-709c-a128-4245591d8de8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c559-709c-a128-4245591d8de8",
        "storage_key": "property/6767906449166338/019d0269-c559-709c-a128-4245591d8de8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc5zq0D2jxokRBTI0YYuI35k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7ef3eebb-08cc-4411-ada8-406caf5f05cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Fort Washington State Park",
      "poi_type": "Recreation",
      "poi_address": "500 S Bethlehem Pike, Fort Washington, PA 19034, USA",
      "poi_short_description": "A popular destination for hiking, picnicking & fishing, this 493-acre park also offers disc golf.",
      "poi_long_description": "A popular destination for hiking, picnicking & fishing, this 493-acre park also offers disc golf.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-9cf5-76b6-b6d9-baddfd9b7037.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-9cf5-76b6-b6d9-baddfd9b7037",
        "storage_key": "property/6767906449166338/019fce05-9cf5-76b6-b6d9-baddfd9b7037.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dcnr.pa.gov/StateParks/FindAPark/FortWashingtonStatePark/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=17757401384840516232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-washington-state-park",
      "poi_latitude": "40.1208988",
      "poi_longitude": "-75.2236592",
      "poi_miles_from_property": "10.1",
      "poi_walking_minutes": "3 hours 41 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 215-591-5250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c559-709c-a128-4245591d8de8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c559-709c-a128-4245591d8de8",
        "storage_key": "property/6767906449166338/019d0269-c559-709c-a128-4245591d8de8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6ayo-Be7xokRiNJyDXr2bvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0058e75d-1349-4ece-bcb1-87cef0dfebb1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Norristown Farm Park",
      "poi_type": "Recreation",
      "poi_address": "2500 Upper Farm Rd, Norristown, PA 19403, USA",
      "poi_short_description": "Green space with 7+ miles of paved trails for biking & hiking plus a stocked trout fishing stream.",
      "poi_long_description": "Green space with 7+ miles of paved trails for biking & hiking plus a stocked trout fishing stream.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-9e04-7618-bc8c-dad76098919a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-9e04-7618-bc8c-dad76098919a",
        "storage_key": "property/6767906449166338/019fce05-9e04-7618-bc8c-dad76098919a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.montcopa.org/874/Norristown-Farm-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10633533103236862035&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "norristown-farm-park",
      "poi_latitude": "40.1430506",
      "poi_longitude": "-75.3468291",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 610-270-0215",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c559-709c-a128-4245591d8de8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c559-709c-a128-4245591d8de8",
        "storage_key": "property/6767906449166338/019d0269-c559-709c-a128-4245591d8de8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnz_mrSyWxokRU1DKvQTmkZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_69d0b1f8-8b4f-4dd9-a324-cf69078143bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Elmwood Park Zoo",
      "poi_type": "Recreation",
      "poi_address": "1661 Harding Blvd, Norristown, PA 19401, USA",
      "poi_short_description": "Small zoo featuring wildlife from around the world like jaguars, zebras and otters.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-a16e-73b9-855a-5ae791b54496.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-a16e-73b9-855a-5ae791b54496",
        "storage_key": "property/6767906449166338/019fce05-a16e-73b9-855a-5ae791b54496.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.elmwoodparkzoo.org/?utm_source=GMB&utm_medium=organic&utm_campaign=1SEO_SM",
      "poi_directions_map_url": "https://maps.google.com/?cid=9161381553617211572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elmwood-park-zoo",
      "poi_latitude": "40.1327855",
      "poi_longitude": "-75.3385921",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 610-277-3825",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd",
        "storage_key": "property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfd-he4i9xokRtJAr4_vDI38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0bd5dadc-1de1-4ab7-b894-49dda5018652",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Valley Forge National Historical Park",
      "poi_type": "Recreation",
      "poi_address": "1400 N Outer Line Dr, King of Prussia, PA 19406, USA",
      "poi_short_description": "Trolley & ranger-led walking tours are offered at this Revolutionary War site with miles of trails.",
      "poi_long_description": "Trolley & ranger-led walking tours are offered at this Revolutionary War site with miles of trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-a354-7479-bcbb-4f6a58d2dacf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-a354-7479-bcbb-4f6a58d2dacf",
        "storage_key": "property/6767906449166338/019fce05-a354-7479-bcbb-4f6a58d2dacf.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.nps.gov/vafo",
      "poi_directions_map_url": "https://maps.google.com/?cid=7978176565380567547&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valley-forge-national-historical-park",
      "poi_latitude": "40.0997055",
      "poi_longitude": "-75.4461131",
      "poi_miles_from_property": "13.3",
      "poi_walking_minutes": "4 hours 52 mins",
      "poi_biking_minutes": "1 hour 37 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 610-783-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c559-709c-a128-4245591d8de8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c559-709c-a128-4245591d8de8",
        "storage_key": "property/6767906449166338/019d0269-c559-709c-a128-4245591d8de8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb_iFIvKTxokR-9Ha5lAtuG4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6f87ed83-c7e1-4ee3-86ba-1036a918a131",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "North Wales Train Station Ticket Office",
      "poi_type": "Transportation",
      "poi_address": "605 Beaver St, North Wales, PA 19454, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-a483-76df-a5f3-f10587e62a29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-a483-76df-a5f3-f10587e62a29",
        "storage_key": "property/6767906449166338/019fce05-a483-76df-a5f3-f10587e62a29.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9647203790603897265&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-wales-train-station-ticket-office",
      "poi_latitude": "40.2144111",
      "poi_longitude": "-75.27745259999999",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 215-699-6237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd",
        "storage_key": "property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ66qy172jxokRsUm_BrzA4YU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bb825998-6150-41ec-8a94-29e03291fb5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Pennbrook Station",
      "poi_type": "Transportation",
      "poi_address": "1114 Church Rd, North Wales, PA 19454, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-a50b-7277-9750-fd43c72f97bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-a50b-7277-9750-fd43c72f97bd",
        "storage_key": "property/6767906449166338/019fce05-a50b-7277-9750-fd43c72f97bd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3442757190328301846&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pennbrook-station",
      "poi_latitude": "40.2301676",
      "poi_longitude": "-75.2815061",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 215-580-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c946-71c4-a8c3-d9bf42f9b1f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c946-71c4-a8c3-d9bf42f9b1f2",
        "storage_key": "property/6767906449166338/019d0269-c946-71c4-a8c3-d9bf42f9b1f2.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ26KbH7qjxokRFrlwkWwhxy8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f97c7902-b2aa-4084-8378-e04103f5f4ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Lansdale Train Station Ticket Office",
      "poi_type": "Transportation",
      "poi_address": "80 W Main St, Lansdale, PA 19446, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-aa15-759c-9b8d-64de9f1fe7e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-aa15-759c-9b8d-64de9f1fe7e3",
        "storage_key": "property/6767906449166338/019fce05-aa15-759c-9b8d-64de9f1fe7e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10306794768869448083&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lansdale-train-station-ticket-office",
      "poi_latitude": "40.243037",
      "poi_longitude": "-75.2851283",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-580-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd",
        "storage_key": "property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu--4hy-jxokRk1lRCzwXCY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bb52f41d-fd29-4ca6-8826-333f9c34ef2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "9th Street",
      "poi_type": "Transportation",
      "poi_address": "141 W 9th St, Lansdale, PA 19446, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-aa24-7549-8061-404768bef5b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-aa24-7549-8061-404768bef5b7",
        "storage_key": "property/6767906449166338/019fce05-aa24-7549-8061-404768bef5b7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.septa.org/stations/rail/9th-street.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=1866933338374454811&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "9th-street",
      "poi_latitude": "40.2501403",
      "poi_longitude": "-75.279186",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c945-734f-be2c-65ff9d27b809.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c945-734f-be2c-65ff9d27b809",
        "storage_key": "property/6767906449166338/019d0269-c945-734f-be2c-65ff9d27b809.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJszaXYtmjxokRG74k1fqt6Bk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b860c909-9f79-44cf-8a4d-760f07eb2618",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Colmar Station",
      "poi_type": "Transportation",
      "poi_address": "2883 Walnut St, North Wales, PA 19454, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.septa.org/stations/colmar-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=1886893577056919154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colmar-station",
      "poi_latitude": "40.268768",
      "poi_longitude": "-75.2543905",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-580-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c946-71c4-a8c3-d9bf42f9b1f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c946-71c4-a8c3-d9bf42f9b1f2",
        "storage_key": "property/6767906449166338/019d0269-c946-71c4-a8c3-d9bf42f9b1f2.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJg16UekmhxokRcp5xDbaXLxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_53c62a41-3154-465b-8d0d-bb2323fd727f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Gwynedd Valley Station",
      "poi_type": "Transportation",
      "poi_address": "521 Plymouth Rd, North Wales, PA 19454, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-ad15-7501-a4b4-3151976cdb21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-ad15-7501-a4b4-3151976cdb21",
        "storage_key": "property/6767906449166338/019fce05-ad15-7501-a4b4-3151976cdb21.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.septa.org/stations/gwynedd-valley-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=12325626692824787111&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gwynedd-valley-station",
      "poi_latitude": "40.184947",
      "poi_longitude": "-75.25679889999999",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 215-580-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c946-71c4-a8c3-d9bf42f9b1f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c946-71c4-a8c3-d9bf42f9b1f2",
        "storage_key": "property/6767906449166338/019d0269-c946-71c4-a8c3-d9bf42f9b1f2.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2YYZB1ujxokRp-jkUyxsDas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a825c832-a5c9-4ec2-b9db-f8d2ec96bcdc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Penllyn",
      "poi_type": "Transportation",
      "poi_address": "Penllyn, PA 19422, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-ae73-7389-9d84-7c618f3390dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-ae73-7389-9d84-7c618f3390dc",
        "storage_key": "property/6767906449166338/019fce05-ae73-7389-9d84-7c618f3390dc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.septa.org/stations/rail/penllyn.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=5395789869302409137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "penllyn",
      "poi_latitude": "40.16961269999999",
      "poi_longitude": "-75.244072",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c945-734f-be2c-65ff9d27b809.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c945-734f-be2c-65ff9d27b809",
        "storage_key": "property/6767906449166338/019d0269-c945-734f-be2c-65ff9d27b809.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJLa5qzlS7xokRsedrSkyy4Uo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ad1fc1fb-d273-4859-bed9-001598ff0d9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Fort Washington, PA (SEPTA Fort Washington Station - Summit Ave Cul-de-Sac. Daily parking is available for a fee in the SEPTA station lot)",
      "poi_type": "Transportation",
      "poi_address": "Whitemarsh Township, PA 19034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18067098811155088374&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-washington-pa-septa-fort-washington-station---summit-ave-cul-de-sac-daily-parking-is-available-for-a-fee-in-the-septa-station-lot",
      "poi_latitude": "40.136052",
      "poi_longitude": "-75.211973",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c96b-73af-a443-c10ded105bbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c96b-73af-a443-c10ded105bbb",
        "storage_key": "property/6767906449166338/019d0269-c96b-73af-a443-c10ded105bbb.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJgW_hTAW7xokR9gPIKKU6u_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3f9bddb5-e0de-438b-8f56-49fe18e39e8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Norristown Transit Center",
      "poi_type": "Transportation",
      "poi_address": "Norristown, PA 19401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-b0ef-76aa-96c4-2381cf5394aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-b0ef-76aa-96c4-2381cf5394aa",
        "storage_key": "property/6767906449166338/019fce05-b0ef-76aa-96c4-2381cf5394aa.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.septa.org/maps/station/ntc.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=5783245876352578000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "norristown-transit-center",
      "poi_latitude": "40.1126365",
      "poi_longitude": "-75.3441404",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c945-734f-be2c-65ff9d27b809.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c945-734f-be2c-65ff9d27b809",
        "storage_key": "property/6767906449166338/019d0269-c945-734f-be2c-65ff9d27b809.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJwwfnKQOWxokR0PG8zHs3QlA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a8f7fd74-3a4c-4b66-bdef-e072a7cf6931",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Philadelphia International Airport",
      "poi_type": "Transportation",
      "poi_address": "8500 Essington Ave, Philadelphia, PA 19153, USA",
      "poi_short_description": "Large hub with direct rail service, rotating art exhibitions & aviation-themed play areas for kids.",
      "poi_long_description": "Large hub with direct rail service, rotating art exhibitions & aviation-themed play areas for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-b0f8-750f-93a7-c1eb7c47c652.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-b0f8-750f-93a7-c1eb7c47c652",
        "storage_key": "property/6767906449166338/019fce05-b0f8-750f-93a7-c1eb7c47c652.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.phl.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4480542405857629144&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "philadelphia-international-airport",
      "poi_latitude": "39.87297969999999",
      "poi_longitude": "-75.24369870000001",
      "poi_miles_from_property": "40.4",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "3 hours 3 mins",
      "poi_driving_minutes": "47 mins",
      "poi_business_phone": "+1 215-937-6937",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c969-7088-9de3-e39bbcc5b455.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c969-7088-9de3-e39bbcc5b455",
        "storage_key": "property/6767906449166338/019d0269-c969-7088-9de3-e39bbcc5b455.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJL4OpYGbExokR2NM3RpQVLj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8b5910a4-21d9-4448-81ef-64d4e3603d1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Merck WestPoint",
      "poi_type": "Major Employers",
      "poi_address": "770 Sumneytown Pike, West Point, PA 19486, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-b3be-7183-bc2e-1071fa2a2235.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-b3be-7183-bc2e-1071fa2a2235",
        "storage_key": "property/6767906449166338/019fce05-b3be-7183-bc2e-1071fa2a2235.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "http://www.merck.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7878097969639173600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "merck-westpoint",
      "poi_latitude": "40.2182474",
      "poi_longitude": "-75.299892",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 215-652-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd",
        "storage_key": "property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb9sbj1aixokR4K0RCl2gVG0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_63a36a6f-f13f-4bcd-a29f-da20f0e7188f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Jefferson Lansdale Hospital",
      "poi_type": "Major Employers",
      "poi_address": "100 Medical Campus Dr, Lansdale, PA 19446, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-8430-75ed-bb4a-f04f304afd0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-8430-75ed-bb4a-f04f304afd0e",
        "storage_key": "property/6767906449166338/019fce05-8430-75ed-bb4a-f04f304afd0e.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.jeffersonhealth.org/locations/jefferson-lansdale-hospital?utm_source=google&utm_medium=organic&utm_campaign=gbp-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1996463513549832306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jefferson-lansdale-hospital",
      "poi_latitude": "40.2504115",
      "poi_longitude": "-75.2714216",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 215-368-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c558-713a-995f-c7b91e92bf7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c558-713a-995f-c7b91e92bf7e",
        "storage_key": "property/6767906449166338/019d0269-c558-713a-995f-c7b91e92bf7e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJs50JId6jxokRcoAq5PzctBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5b5bf919-c8fa-450e-9195-be73ee7461cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Spring House Innovation Park",
      "poi_type": "Major Employers",
      "poi_address": "727 Norristown Rd, Lower Gwynedd Township, PA 19002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-b6f3-710e-a8c7-105b1af49541.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-b6f3-710e-a8c7-105b1af49541",
        "storage_key": "property/6767906449166338/019fce05-b6f3-710e-a8c7-105b1af49541.webp",
        "width": 1280,
        "height": 874
      },
      "poi_business_url": "http://springhouseinnovationpark.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16163222073178669826&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-house-innovation-park",
      "poi_latitude": "40.1845262",
      "poi_longitude": "-75.2143372",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 610-251-5126",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd",
        "storage_key": "property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9Z7vP0ClxokRAkOR0dZMT-A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_01c44f67-87fa-4fe5-8d6a-86ec4f5f828f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Montgomery County Community College",
      "poi_type": "Major Employers",
      "poi_address": "340 Dekalb Pike, Blue Bell, PA 19422, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-b936-7367-a151-ca033c177995.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-b936-7367-a151-ca033c177995",
        "storage_key": "property/6767906449166338/019fce05-b936-7367-a151-ca033c177995.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mc3.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2943399387633382788&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "montgomery-county-community-college",
      "poi_latitude": "40.1765166",
      "poi_longitude": "-75.276761",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 215-641-6551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c55b-7726-a540-6c31c11f8fb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c55b-7726-a540-6c31c11f8fb7",
        "storage_key": "property/6767906449166338/019d0269-c55b-7726-a540-6c31c11f8fb7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_4z7XzOjxokRhHX98yUO2Sg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_da681b3d-0948-42d5-9014-5f7ae465bf37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Gwynedd Mercy University",
      "poi_type": "Major Employers",
      "poi_address": "1325 Sumneytown Pike, Gwynedd Valley, PA 19437, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-7302-70da-af16-1046c96e564c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-7302-70da-af16-1046c96e564c",
        "storage_key": "property/6767906449166338/019fce05-7302-70da-af16-1046c96e564c.webp",
        "width": 1280,
        "height": 815
      },
      "poi_business_url": "https://www.gmercyu.edu/?utm_source=google&utm_medium=organic&utm_campaign=gmbmain",
      "poi_directions_map_url": "https://maps.google.com/?cid=4817100659531784388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gwynedd-mercy-university",
      "poi_latitude": "40.1979262",
      "poi_longitude": "-75.2368884",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 215-646-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-c55b-7726-a540-6c31c11f8fb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-c55b-7726-a540-6c31c11f8fb7",
        "storage_key": "property/6767906449166338/019d0269-c55b-7726-a540-6c31c11f8fb7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk_AnaIGexokRxCCxGofH2UI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c71820b8-5e54-4efb-bdb6-b18e48031a9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Montgomery County Courthouse",
      "poi_type": "Major Employers",
      "poi_address": "2 E Airy St, Norristown, PA 19401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-b84e-75c9-85da-f2f9271e7dab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-b84e-75c9-85da-f2f9271e7dab",
        "storage_key": "property/6767906449166338/019fce05-b84e-75c9-85da-f2f9271e7dab.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.montcopa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12379780792949452697&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "montgomery-county-courthouse",
      "poi_latitude": "40.1155755",
      "poi_longitude": "-75.3438414",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 610-278-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-cd54-734a-9e96-0f792d79a917.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-cd54-734a-9e96-0f792d79a917",
        "storage_key": "property/6767906449166338/019d0269-cd54-734a-9e96-0f792d79a917.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq4krBh2WxokRma_0UArRzas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_481c57c9-21ff-4c56-bfd6-a77bac953191",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "North Wales Borough Hall",
      "poi_type": "Major Employers",
      "poi_address": "300 School St, North Wales, PA 19454, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-b9d7-773c-824d-eb31e983071a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-b9d7-773c-824d-eb31e983071a",
        "storage_key": "property/6767906449166338/019fce05-b9d7-773c-824d-eb31e983071a.webp",
        "width": 1280,
        "height": 662
      },
      "poi_business_url": "https://northwalesborough.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11526026463646435982&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-wales-borough-hall",
      "poi_latitude": "40.2131058",
      "poi_longitude": "-75.2792324",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 215-699-4424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-cd54-734a-9e96-0f792d79a917.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-cd54-734a-9e96-0f792d79a917",
        "storage_key": "property/6767906449166338/019d0269-cd54-734a-9e96-0f792d79a917.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPeFSpQmjxokRjsplTQCs9J8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_85bb9152-3f97-4492-a127-79ccb95d4103",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "SKF - America's Headquarters",
      "poi_type": "Major Employers",
      "poi_address": "801 Lakeview Dr, Blue Bell, PA 19422, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-bd40-77ad-8e9c-cb080ecf8240.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-bd40-77ad-8e9c-cb080ecf8240",
        "storage_key": "property/6767906449166338/019fce05-bd40-77ad-8e9c-cb080ecf8240.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.skf.com/us/organisation/about-skf-usa-inc",
      "poi_directions_map_url": "https://maps.google.com/?cid=2309987967910391057&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "skf---americas-headquarters",
      "poi_latitude": "40.1421111",
      "poi_longitude": "-75.2869726",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 267-436-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd",
        "storage_key": "property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFX04sRyixokREa25ZtG5DiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4b2d119f-b0d0-4f3b-9abf-cebf6b9fd709",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Tyco",
      "poi_type": "Major Employers",
      "poi_address": "1400 Pennbrook Pkwy, Lansdale, PA 19446, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.tyco-fire.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18363543291861388833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tyco",
      "poi_latitude": "40.2300106",
      "poi_longitude": "-75.28574440000001",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 215-362-0700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd",
        "storage_key": "property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8ZCT2LCjxokRIc7naFRp2P4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5c0112bd-2d7a-42e3-a629-5da20006b995",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "poi_name": "Jefferson Health – Montgomeryville",
      "poi_type": "Major Employers",
      "poi_address": "1010 Horsham Rd, North Wales, PA 19454, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-c00d-728e-b7e7-fd35870ee377.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce05-c00d-728e-b7e7-fd35870ee377",
        "storage_key": "property/6767906449166338/019fce05-c00d-728e-b7e7-fd35870ee377.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.jeffersonhealth.org/locations/montgomeryville",
      "poi_directions_map_url": "https://maps.google.com/?cid=5280610393145192560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jefferson-health--montgomeryville",
      "poi_latitude": "40.2391692",
      "poi_longitude": "-75.23145339999999",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-481-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd",
        "storage_key": "property/6767906449166338/019d0269-bf8c-738a-b4a9-d2c1dcf1e8fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__-vDhqkxokRcLCnuCx_SEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_a306bb40-afde-4220-a0ee-e8c9736e337e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_04093428-0ebc-48fb-b6c0-e4cb4abb9cf1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1c2edccf-2d39-425a-b040-902eeb716313",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_5366d14d-fa8a-4ad3-bdbf-3daa6c971e14",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_9a3274c9-d073-4e3d-a6db-56991da4f71b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_85287707-3121-497a-b9fc-420d71d6ada3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_d744959d5d4fd082c1dd3231",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "rating": "4",
      "name": "false",
      "text": "Old, but well maintained apartments. Friendly staff, quick response, I've had minor issues late at night which were fixed within minutes. I've lived here for 2 years and will recommend to others. 1 bedrooms are great, 2 bedrooms are a little cramped.",
      "date": "false",
      "title": "Well maintained apartments for affordable rates"
    },
    {
      "id": "ec_c82bddfdff046c1b8aab3a40",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "rating": "5",
      "name": "false",
      "text": "I will say if I need to move back to the area, I would choose this apt complex without a doubt. I lived there 7 years. I had a 1 bdrm apt 2nd floor. Loved the closet space. For me, the apt was a perfect size and it was homey. When I had maintence issues, they were called in quick! I will say the maintenance team is great! They seriously get it done. I seriously have no negative issues with this apt complex. Thank you for making this my home for 7 years! ",
      "date": "false",
      "title": "I loved this complex! "
    },
    {
      "id": "ec_7e6a73214d331b0bf99e16c4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "rating": "5",
      "name": "false",
      "text": "The new community of Staff that work there are so supportive, and knowledgeable! Great place to live! ",
      "date": "false",
      "title": "New Company Takeover is this best! "
    },
    {
      "id": "ec_1c8b13d329a18d5a5998dd2d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "rating": "5",
      "name": "false",
      "text": "They are horrible this has to be the worst management on the planet earth they will put you in a unfinished unit and hide the things that need to be repaired don’t do it please ",
      "date": "false",
      "title": "management is horrible "
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_a6355418-0fed-4f8c-a83e-b8b4c0968c4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fa55d-fb34-720a-966e-673d5b9b3c41.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fa55d-fb34-720a-966e-673d5b9b3c41",
        "storage_key": "property/6767906449166338/019fa55d-fb34-720a-966e-673d5b9b3c41.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": " Parc at West Point",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=63331bf56578507ebe665fb6&sourceId=1001"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_dfb398978e8fa277504893f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "engrain",
      "external_id": "429560",
      "name": "Amenity Fee",
      "description": "false",
      "amount": 250,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_1f36544d687f2f93437bf4b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "engrain",
      "external_id": "429562",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_7e4f3560620942abee776b27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "engrain",
      "external_id": "429563",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_045d054ae788871867183db6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "engrain",
      "external_id": "429564",
      "name": "Pet Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a358311dbed8a585fc50a7dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "engrain",
      "external_id": "429566",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_f9229af18fbf7a547773052b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "engrain",
      "external_id": "429567",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "50.00 / 25.00",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_efe618aaf5be549a8e525527",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "engrain",
      "external_id": "429570",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_73cdd1069b4c28633823a26f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "engrain",
      "external_id": "429571",
      "name": "Transfer Fee",
      "description": "false",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_012f6054a03afd48b128e2ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "engrain",
      "external_id": "541024",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_e1816e6c8a8bde7a3a9c657e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "engrain",
      "external_id": "541025",
      "name": "Utility - Administrative Billing Fee",
      "description": "false",
      "amount": 4.66,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4f125563d6a4282130ffb61b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "engrain",
      "external_id": "541026",
      "name": "Trash Service",
      "description": "false",
      "amount": 14,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_b7251024fc70f9fa1768fe58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "engrain",
      "external_id": "543125",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6bcf09b7c1d5cf42d3ca9196",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "engrain",
      "external_id": "543127",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_dfe5606d91a05eb1f685d9c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "engrain",
      "external_id": "543128",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_e6f5f94509a4e068447408d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "engrain",
      "external_id": "835267",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_b43796d1be2d5a2bdb729e8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "engrain",
      "external_id": "835269",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_daa5d5c725c89ca67eb1dbdf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "engrain",
      "external_id": "835270",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_9c6173a2ff4332d100f57158",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "engrain",
      "external_id": "835271",
      "name": "Lockout Fee - After Hours",
      "description": "false",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_9d9dfb8863bd0fa08c7c2c24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "engrain",
      "external_id": "835272",
      "name": "Amenity Fee - Renewal",
      "description": "false",
      "amount": 175,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Annually, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a8a60574c708ef502030fb6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "engrain",
      "external_id": "835290",
      "name": "Admin Fee",
      "description": "Assessed per occurrence for any modification to the Lease Agreement, including but not limited to the addition, removal, or substitution of any leaseholder or occupant.",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a131c-3994-727a-a85e-97f7bbbe32b0",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-parc-at-west-point-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338"
    },
    {
      "lead_collector_id": "019c3043-8a89-75ca-9ae6-1a18ea1636cc",
      "lead_source": "FACEBOOK_ADS",
      "name": "parc-at-west-point",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338"
    },
    {
      "lead_collector_id": "019c3043-8af6-7756-b05b-379324cb722a",
      "lead_source": "LANDING_PAGE",
      "name": "parc-at-west-point",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "page_item_url": "dog-friendly-apartments-north-wales-pa-135",
      "search_query": "dog friendly apartments North Wales PA",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments in North Wales, PA",
      "h2_subtitle": "Find your perfect pet-friendly apartment at Parc at West Point, located in North Wales, PA. Enjoy amenities designed to cater to you and your pet's needs.",
      "page_copy": "Welcome to Parc at West Point, where you'll discover the perfect dog friendly apartments North Wales PA has to offer. Situated in the heart of Montgomery County, our community harmoniously blends comfort and leisure with pet-friendly living. Your four-legged friend will love the spacious surroundings, just as much as you will enjoy the renovated interiors, complete with high-speed internet and a cozy fireplace.\n\nLocated conveniently near local parks and trails, Parc at West Point provides an ideal setting for both relaxation and adventure with your pet. Walk through our scenic neighborhood or make use of the nearby playground facilities. With a choice of one, two, or three-bedroom floor plans, our versatile layouts cater to all your pet-friendly needs, setting the perfect backdrop for a vibrant community experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
      "featured_image_media": {
        "alt_text": "Stainless steel refrigerator and dark wood cabinets in a kitchen.",
        "public_id": "01a015db-1bd3-77dd-bc6b-bc842a82e5bd",
        "storage_key": "property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments, North Wales, PA",
      "seo_description": "Explore dog friendly apartments in North Wales, PA at Parc at West Point. Enjoy pet-friendly amenities for you and your furry friend.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "page_item_url": "apartments-with-pool-montgomery-county-pa-430",
      "search_query": "apartments with pool Montgomery County PA",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Montgomery County, PA",
      "h2_subtitle": "Discover Parc at West Point in Montgomery County, PA. Our sparkling pool is just one of the many amenities you'll enjoy in our community.",
      "page_copy": "Dive into comfort at Parc at West Point, offering premier apartments with pool Montgomery County PA residents love. Our sparkling pool provides residents a retreat for relaxation and fun during the warm months. Coupled with our beautifully maintained grounds, featuring a playground and pet-friendly facilities, you'll find endless opportunities to unwind and enjoy.\n\nSituated in North Wales, PA, our community offers more than just a pool. Choose from expertly designed one, two, or three-bedroom floor plans, all including high-speed internet access and homey fireplaces. With a location near shopping, dining, and local attractions, Parc at West Point creates the perfect backdrop for both exciting and peaceful living, making it an ideal choice for those seeking leisure-filled days in Montgomery County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
      "featured_image_media": {
        "alt_text": "Stainless steel refrigerator and dark wood cabinets in a kitchen.",
        "public_id": "01a015db-1bd3-77dd-bc6b-bc842a82e5bd",
        "storage_key": "property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool, Montgomery County, PA",
      "seo_description": "Discover apartments with a pool in Montgomery County, PA at Parc at West Point. Dive into comfort with our premium amenities and spacious floor plans.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "page_item_url": "dedicated-parking-apartments-near-19454-408",
      "search_query": "dedicated parking apartments near 19454",
      "category": "Amenity",
      "h1_title": "Dedicated Parking Apartments Near 19454",
      "h2_subtitle": "Parc at West Point offers dedicated parking among its many features. Find your perfect apartment near the 19454 area today.",
      "page_copy": "Located conveniently near North Wales' 19454 ZIP code, Parc at West Point presents dedicated parking apartments that cater to resident needs for ease and accessibility. Our community is designed with comfort in mind, providing residents with seamless access to their vehicles, ensuring your daily commutes and excursions are stress-free and efficient.\n\nBeyond parking, Parc at West Point delivers a comprehensive living experience. Enjoy our sparkling pool, spacious playground, and pet-friendly policies that set us apart as a prime living destination in Montgomery County. Our one, two, and three-bedroom floor plans are enriched with amenities like high-speed internet and cozy fireplaces, promising a lifestyle that blends convenience with leisure.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
      "featured_image_media": {
        "alt_text": "Stainless steel refrigerator and dark wood cabinets in a kitchen.",
        "public_id": "01a015db-1bd3-77dd-bc6b-bc842a82e5bd",
        "storage_key": "property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dedicated Parking Apartments Near 19454",
      "seo_description": "Secure apartments with dedicated parking near the 19454 area at Parc at West Point. Enjoy easy access and premium facilities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "page_item_url": "air-conditioned-apartment-homes-north-wales-798",
      "search_query": "air conditioned apartment homes North Wales",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartment Homes in North Wales",
      "h2_subtitle": "Experience comfort at Parc at West Point in North Wales. Our air conditioned apartment homes provide the perfect retreat from summer heat.",
      "page_copy": "Stay cool and comfortable at Parc at West Point, offering premier air conditioned apartment homes North Wales residents love. Nestled in the heart of Montgomery County, our community ensures optimal comfort with air conditioning available in each of our stylish one, two, and three-bedroom floor plans. You can enjoy the convenience of temperature-controlled living rooms while relaxing in front of a cozy fireplace.\n\nOur amenities don't stop at air conditioning. Dive into our sparkling pool, utilize high-speed internet, and explore pet-friendly spaces perfect for every member of your family. Located close to major shopping and dining options in North Wales, Parc at West Point is the ideal location for those seeking a balanced lifestyle in a vibrant community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
      "featured_image_media": {
        "alt_text": "Stainless steel refrigerator and dark wood cabinets in a kitchen.",
        "public_id": "01a015db-1bd3-77dd-bc6b-bc842a82e5bd",
        "storage_key": "property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartment Homes, North Wales",
      "seo_description": "Find air conditioned apartment homes in North Wales at Parc at West Point. Enjoy year-round comfort with premium amenities and ideal location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "page_item_url": "apartments-with-dishwashers-montgomery-county-534",
      "search_query": "apartments with dishwashers Montgomery County",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwashers in Montgomery County",
      "h2_subtitle": "Discover the convenience of apartments with dishwashers at Parc at West Point, Montgomery County. Make everyday living easy and efficient.",
      "page_copy": "Simplify your daily chores at Parc at West Point, where our apartments with dishwashers in Montgomery County offer the perfect blend of convenience and comfort. Each of our thoughtfully designed one, two, and three-bedroom homes is equipped with modern appliances, including efficient dishwashers, allowing you more time to enjoy life and less time at the sink.\n\nBeyond the kitchen, our community offers a vibrant living experience. Relax by our sparkling pool, or enjoy high-speed internet from the comfort of your renovated home. Located in North Wales, Parc at West Point is in a prime location for accessing local shops and attractions, providing a lifestyle filled with both convenience and entertainment, ideal for those who seek the best in apartment living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
      "featured_image_media": {
        "alt_text": "Stainless steel refrigerator and dark wood cabinets in a kitchen.",
        "public_id": "01a015db-1bd3-77dd-bc6b-bc842a82e5bd",
        "storage_key": "property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwashers, Montgomery County",
      "seo_description": "Explore apartments with dishwashers in Montgomery County at Parc at West Point. Enjoy modern conveniences and premium amenities in our vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-north-wales-pa-328",
      "search_query": "1 bedroom apartments in North Wales PA",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in North Wales, PA",
      "h2_subtitle": "Find your ideal 1 bedroom apartment at Parc at West Point in North Wales, PA. Enjoy comfort and style in our thoughtfully designed spaces.",
      "page_copy": "Discover the perfect blend of comfort and convenience at Parc at West Point, offering stylish 1 bedroom apartments in North Wales, PA. Our community is designed to meet modern living needs, providing spacious layouts complemented by premium amenities such as high-speed internet and cozy fireplaces, ensuring every resident feels right at home.\n\nBeyond individual apartment comforts, Parc at West Point invites you to enjoy a vibrant community setting. Dive into our sparkling pool, explore the playground, or take advantage of our pet-friendly spaces. Ideally located in Montgomery County, you're just a short distance from local dining, shopping, and entertainment, making our 1 bedroom apartments the ideal choice for singles and couples seeking a dynamic lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
      "featured_image_media": {
        "alt_text": "Stainless steel refrigerator and dark wood cabinets in a kitchen.",
        "public_id": "01a015db-1bd3-77dd-bc6b-bc842a82e5bd",
        "storage_key": "property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments, North Wales PA",
      "seo_description": "Explore 1 bedroom apartments in North Wales, PA at Parc at West Point. Enjoy stylish living with convenient amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-montgomery-county-312",
      "search_query": "2 bedroom apartments Montgomery County",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Montgomery County",
      "h2_subtitle": "Explore spacious 2 bedroom apartments at Parc at West Point in Montgomery County. Enjoy modern amenities and a vibrant community setting.",
      "page_copy": "Experience enhanced living at Parc at West Point where our 2 bedroom apartments in Montgomery County offer the perfect balance of space and comfort. Each apartment is thoughtfully designed with modern conveniences, such as electric ranges and high-speed internet, ensuring you enjoy a seamless living experience. Whether you're cooking up a storm in the kitchen or unwinding by the fireplace, every detail is crafted with you in mind.\n\nIn addition to well-appointed interiors, our community enhances everyday life with a range of amenities including a sparkling pool and pet-friendly facilities. Located in the vibrant area of North Wales, Parc at West Point provides easy access to local dining and shopping, making our 2 bedroom apartments an ideal choice for families and roommates alike who seek both comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
      "featured_image_media": {
        "alt_text": "Stainless steel refrigerator and dark wood cabinets in a kitchen.",
        "public_id": "01a015db-1bd3-77dd-bc6b-bc842a82e5bd",
        "storage_key": "property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments, Montgomery County",
      "seo_description": "Discover 2 bedroom apartments in Montgomery County at Parc at West Point. Enjoy spacious living with modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "page_item_url": "3-bedroom-apartment-near-19454-846",
      "search_query": "3 bedroom apartment near 19454",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartment Near 19454",
      "h2_subtitle": "Discover spacious living with a 3 bedroom apartment at Parc at West Point, conveniently located near the 19454 area.",
      "page_copy": "Welcome home to Parc at West Point, where our expansive 3 bedroom apartments offer the ideal living solution near the 19454 zip code. Perfect for families or those needing extra space, each apartment comes with modern amenities, including high-speed internet, and an electric range in the kitchen, designed to enhance your daily living experience. Enjoy the warmth of a stylish fireplace, creating the perfect ambiance for your evenings.\n\nOur community is packed with amenities that cater to an active lifestyle—relax by the pool, or let your pets enjoy our pet-friendly spaces. Situated in North Wales, PA, Parc at West Point provides a central location, granting quick access to local services and entertainment. Choose our 3 bedroom apartments for a blend of convenience and comfort just a stone's throw from all that Montgomery County has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
      "featured_image_media": {
        "alt_text": "Stainless steel refrigerator and dark wood cabinets in a kitchen.",
        "public_id": "01a015db-1bd3-77dd-bc6b-bc842a82e5bd",
        "storage_key": "property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartment Near 19454",
      "seo_description": "Find a spacious 3 bedroom apartment near 19454 at Parc at West Point. Enjoy modern living with fantastic amenities in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "page_item_url": "apartments-near-mccc-north-wales-679",
      "search_query": "apartments near montgomery county community college north wales",
      "category": "School",
      "h1_title": "Apartments Near Montgomery County Community College",
      "h2_subtitle": "Discover ideal living at Parc at West Point, with apartments conveniently located near Montgomery County Community College in North Wales.",
      "page_copy": "Parc at West Point offers the perfect home base for students and faculty seeking convenient apartments near Montgomery County Community College in North Wales. Our community provides a selection of stylish one, two, and three-bedroom floor plans that cater to various lifestyles and needs. Enjoy modern amenities such as high-speed internet and fully equipped kitchens with electric ranges, making it easier to focus on studies or unwind after a busy day.\n\nIdeally located in North Wales, Parc at West Point allows easy access not only to the college but also to local dining, shopping, and entertainment options. Residents can relax by our pool, let children explore the playground, or enjoy pet-friendly spaces, all within a welcoming community atmosphere. Choose Parc at West Point for the ultimate blend of comfort, convenience, and community engagement near Montgomery County Community College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
      "featured_image_media": {
        "alt_text": "Stainless steel refrigerator and dark wood cabinets in a kitchen.",
        "public_id": "01a015db-1bd3-77dd-bc6b-bc842a82e5bd",
        "storage_key": "property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Montgomery County Community College",
      "seo_description": "Find apartments near Montgomery County Community College at Parc at West Point in North Wales. Enjoy convenience and modern living amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "page_item_url": "apartments-near-gwynedd-mercy-university-969",
      "search_query": "apartments near gwynedd mercy university montgomery county",
      "category": "School",
      "h1_title": "Apartments Near Gwynedd Mercy University",
      "h2_subtitle": "Explore comfortable living at Parc at West Point, with apartments conveniently accessible to Gwynedd Mercy University in Montgomery County.",
      "page_copy": "Parc at West Point is your go-to destination for convenient and comfortable living near Gwynedd Mercy University in Montgomery County. Our community offers a variety of well-designed one, two, and three-bedroom apartments perfect for students, faculty, and staff. Each unit is equipped with modern features including high-speed internet and electric ranges, ensuring a stress-free lifestyle as you balance work and academics.\n\nLocated in the heart of North Wales, our community provides easy access to Gwynedd Mercy University and a wealth of local dining and shopping venues. Take advantage of our on-site amenities like the pool and playground, which offer a relaxing escape right at home. Parc at West Point is your ideal choice for vibrant and connected living near Gwynedd Mercy University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
      "featured_image_media": {
        "alt_text": "Stainless steel refrigerator and dark wood cabinets in a kitchen.",
        "public_id": "01a015db-1bd3-77dd-bc6b-bc842a82e5bd",
        "storage_key": "property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Gwynedd Mercy University",
      "seo_description": "Discover apartments near Gwynedd Mercy University at Parc at West Point in Montgomery County. Enjoy modern living close to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "page_item_url": "apartments-near-jefferson-einstein-montgomery-hospital-697",
      "search_query": "apartments near Jefferson Einstein Montgomery Hospital Montgomery County",
      "category": "Hospital",
      "h1_title": "Apartments Near Jefferson Einstein Montgomery Hospital",
      "h2_subtitle": "Find ideal living at Parc at West Point, conveniently located close to Jefferson Einstein Montgomery Hospital in Montgomery County.",
      "page_copy": "Situated in North Wales, Parc at West Point provides a convenient home base for professionals and families seeking apartments near Jefferson Einstein Montgomery Hospital in Montgomery County. Our selection includes spacious one, two, and three-bedroom apartments, each designed with comfort and modernity in mind. High-speed internet and electric ranges are standard, ensuring a daily living experience that is both efficient and enjoyable.\n\nLiving at Parc at West Point means enjoying a vibrant community with exceptional amenities like a sparkling pool and a children's playground, enhancing your leisure time. The community's location offers easy access not only to Jefferson Einstein Montgomery Hospital but also to a myriad of local dining spots and retail options. Choose Parc at West Point for a harmonious blend of convenience and comfort near major health facilities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
      "featured_image_media": {
        "alt_text": "Stainless steel refrigerator and dark wood cabinets in a kitchen.",
        "public_id": "01a015db-1bd3-77dd-bc6b-bc842a82e5bd",
        "storage_key": "property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Jefferson Einstein Montgomery Hospital",
      "seo_description": "Explore comfortable apartments near Jefferson Einstein Montgomery Hospital at Parc at West Point in Montgomery County. Convenient, modern living awaits.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "page_item_url": "living-near-jefferson-lansdale-hospital-635",
      "search_query": "living near Jefferson Lansdale Hospital North Wales PA",
      "category": "Hospital",
      "h1_title": "Living Near Jefferson Lansdale Hospital",
      "h2_subtitle": "Experience modern living at Parc at West Point, conveniently located near Jefferson Lansdale Hospital in North Wales, PA.",
      "page_copy": "Discover the convenience and comfort of living near Jefferson Lansdale Hospital at Parc at West Point, located in North Wales, PA. Our community features a selection of one, two, and three-bedroom apartments, perfectly suited for healthcare professionals or anyone seeking a home near quality medical facilities. Each apartment is designed with functionality in mind, offering amenities like high-speed internet and electric ranges to simplify daily routines.\n\nParc at West Point not only provides easy access to Jefferson Lansdale Hospital but also boasts a dynamic community atmosphere, complete with a pool and playground. You'll also find an array of dining and shopping options nearby, enhancing the experience of living in North Wales. Choose Parc at West Point for a blend of comfort, convenience, and community spirit right at the doorstep of key healthcare services.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
      "featured_image_media": {
        "alt_text": "Stainless steel refrigerator and dark wood cabinets in a kitchen.",
        "public_id": "01a015db-1bd3-77dd-bc6b-bc842a82e5bd",
        "storage_key": "property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Jefferson Lansdale Hospital",
      "seo_description": "Enjoy convenient living near Jefferson Lansdale Hospital at Parc at West Point in North Wales, PA. Modern amenities and an ideal location await.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "page_item_url": "apartments-near-lions-pride-park-north-wales-151",
      "search_query": "apartments near Lions Pride Park North Wales",
      "category": "Park",
      "h1_title": "Apartments Near Lions Pride Park",
      "h2_subtitle": "Discover ideal living at Parc at West Point, with apartments just a short distance from Lions Pride Park in North Wales.",
      "page_copy": "Parc at West Point offers the perfect apartment community for those seeking proximity to Lions Pride Park in North Wales. Our variety of one, two, and three-bedroom layouts cater to various lifestyles, providing residents with an exceptional living environment combined with modern amenities like electric ranges and high-speed internet. \n\nLions Pride Park, a local favorite, is just a short distance away, offering recreational fun and outdoor relaxation. At Parc at West Point, residents also enjoy a host of community amenities such as a sparkling pool and a children's playground, creating a balanced lifestyle loved by all. Whether you're relaxing at home or exploring the vibrant local scene, Parc at West Point ensures a convenient and enjoyable living experience near Lions Pride Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
      "featured_image_media": {
        "alt_text": "Stainless steel refrigerator and dark wood cabinets in a kitchen.",
        "public_id": "01a015db-1bd3-77dd-bc6b-bc842a82e5bd",
        "storage_key": "property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lions Pride Park",
      "seo_description": "Explore Parc at West Point for apartments near Lions Pride Park in North Wales. Enjoy modern amenities and a great community location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "page_item_url": "north-wales-apartments-near-evansburg-state-park-299",
      "search_query": "North Wales apartments near Evansburg State Park",
      "category": "Park",
      "h1_title": "North Wales Apartments Near Evansburg State Park",
      "h2_subtitle": "Discover the charm of living at Parc at West Point, conveniently located near Evansburg State Park in North Wales.",
      "page_copy": "Parc at West Point in North Wales, PA, offers the ideal setting for those seeking proximity to the natural beauty of Evansburg State Park. Our community provides a wide range of one, two, and three-bedroom apartments equipped with modern features like high-speed internet and electric ranges to enhance everyday living. \n\nJust a short drive away, Evansburg State Park provides a picturesque escape for outdoor enthusiasts with its trails and picnic areas. Residents at Parc at West Point enjoy a well-rounded lifestyle, with community amenities such as a pool and playground adding to the appeal. It's the perfect place for those who love both the convenience of contemporary living and the excitement of nearby nature adventures.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
      "featured_image_media": {
        "alt_text": "Stainless steel refrigerator and dark wood cabinets in a kitchen.",
        "public_id": "01a015db-1bd3-77dd-bc6b-bc842a82e5bd",
        "storage_key": "property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "North Wales Apartments Near Evansburg Park",
      "seo_description": "Find your home at Parc at West Point, offering North Wales apartments near Evansburg State Park. Modern living meets natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166338",
      "source": "custom",
      "page_item_url": "fishers-park-nearby-apartments-montgomery-county-365",
      "search_query": "Fischer's Park nearby apartments Montgomery County",
      "category": "Park",
      "h1_title": "Apartments Near Fischer's Park",
      "h2_subtitle": "Explore Parc at West Point, offering welcoming apartments conveniently located near Fischer's Park in Montgomery County.",
      "page_copy": "Located in the heart of Montgomery County, Parc at West Point is your gateway to exceptional apartment living with Fischer's Park just a short distance away. Our community offers one, two, and three-bedroom apartments, each featuring modern amenities such as electric ranges and high-speed internet, ensuring a top-notch living experience.\n\nFischer's Park provides a fantastic nearby retreat with its expansive grounds and numerous recreational opportunities. Whether you enjoy picnics, walking trails, or simply relaxing in nature, this park enhances your lifestyle at Parc at West Point. Coupled with community amenities like a playground and swimming pool, residents can embrace a vibrant, active lifestyle nestled comfortably in Montgomery County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
      "featured_image_media": {
        "alt_text": "Stainless steel refrigerator and dark wood cabinets in a kitchen.",
        "public_id": "01a015db-1bd3-77dd-bc6b-bc842a82e5bd",
        "storage_key": "property/6767906449166338/01a015db-1bd3-77dd-bc6b-bc842a82e5bd.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Fischer's Park",
      "seo_description": "Parc at West Point offers apartments near Fischer's Park in Montgomery County. Enjoy modern living and easy access to outdoor activities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5075"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976275613"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973425"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N59D3BNH"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://parcatwestpoint.fatwin.com/api/websites/resources/1?x=ZWpoc21Zb3V1cysxcm9ySG40WjRQRzMwRXR5M3paSElIdVE1NUdHL084eDJCMG5FR3c0TUV3emVMQUYxeWE2Rk8xeCtTVUJsaFBLeE83eDV0N3F1ZWc9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Belmont"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/1ywym061wq0tan"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "954915aa-43e6-11ef-85fd-5f061b21e75f"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954915aa-43e6-11ef-85fd-5f061b21e75f/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954915aa-43e6-11ef-85fd-5f061b21e75f/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjlnMUhNdmZMcDRwQkhIWFJVZ0I0K2c9PSIsInZhbHVlIjoiUGluUEsydG1XcmQ1SXppWC9sb3pWZz09IiwibWFjIjoiZDI4MDk4MzRjYmZjYWVmM2I1MjNhMTBhMzhkMTM4MjIzZjc3MTQzYWRkNDYwNDRlNTdiNzA2OGQ2NmJiZTdkOCJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5075",
  "custom_repli_id": "9976275613",
  "custom_realpage_id": "4973425",
  "custom_google_gtm_id": "GTM-N59D3BNH",
  "custom_perq_script_url": "https://parcatwestpoint.fatwin.com/api/websites/resources/1?x=ZWpoc21Zb3V1cysxcm9ySG40WjRQRzMwRXR5M3paSElIdVE1NUdHL084eDJCMG5FR3c0TUV3emVMQUYxeWE2Rk8xeCtTVUJsaFBLeE83eDV0N3F1ZWc9PQ2",
  "custom_vibesites_theme": "Belmont",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/1ywym061wq0tan",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "954915aa-43e6-11ef-85fd-5f061b21e75f",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954915aa-43e6-11ef-85fd-5f061b21e75f/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954915aa-43e6-11ef-85fd-5f061b21e75f/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjlnMUhNdmZMcDRwQkhIWFJVZ0I0K2c9PSIsInZhbHVlIjoiUGluUEsydG1XcmQ1SXppWC9sb3pWZz09IiwibWFjIjoiZDI4MDk4MzRjYmZjYWVmM2I1MjNhMTBhMzhkMTM4MjIzZjc3MTQzYWRkNDYwNDRlNTdiNzA2OGQ2NmJiZTdkOCJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "15c6d58b-8eb6-440e-84c1-5b2416998e75",
  "custom_audioeye_site_hash": "8d1f677e569727e84f4c1fd6c4473674"
};

export const generatedAt = '2026-10-22T20:05:54.384Z';
